<template>
  <div class="teacher-page d-flex">
    <aside class="side-nav" :class="{ collapsed: sidebarCollapsed }">
      <div class="side-head">
        <h4 class="mb-0" v-show="!sidebarCollapsed">教师端</h4>
        <button class="collapse-btn" @click="toggleSidebar">{{ sidebarCollapsed ? '>>' : '<<' }}</button>
      </div>
      <button class="sub-btn" @click="goQuestionManage"><span class="nav-text">题库管理</span></button>
      <button class="sub-btn" :class="{ active: activeMenu === 'paper' }" @click="setActiveMenu('paper')"><span class="nav-text">试卷管理</span></button>
      <button class="sub-btn" :class="{ active: activeMenu === 'exam' }" @click="setActiveMenu('exam')"><span class="nav-text">考试管理</span></button>
      <button class="sub-btn" :class="{ active: activeMenu === 'grading' }" @click="setActiveMenu('grading')"><span class="nav-text">阅卷管理</span></button>
      <button class="sub-btn" @click="goExamRecordManage"><span class="nav-text">考生试卷管理</span></button>
      <button class="sub-btn" @click="goProctor"><span class="nav-text">监考系统</span></button>
      <button class="sub-btn" @click="goStudentUsers"><span class="nav-text">学生用户管理</span></button>
      <div class="mt-auto">
        <button class="btn btn-sm btn-light w-100 mb-2" @click="logout">退出登录</button>
      </div>
    </aside>

    <main class="content-area">
      <header class="topbar">
        <h2>{{ activeMenu === 'paper' ? '试卷管理系统' : '考试管理系统' }}</h2>
        <div class="actions">
          <span class="text-muted small">当前账号：{{ currentUser.username || '教师' }}</span>
        </div>
      </header>

      <section class="card-box" v-if="activeMenu === 'paper'">
        <h4>试卷创建 / 编辑</h4>
        <p class="small text-muted mb-2">试卷只配置题目与分值；开考/结束时间请到「考试管理」中设置。</p>
        <div class="paper-form-grid mb-3">
          <div class="paper-form-item">
            <label class="paper-form-label">试卷名称：</label>
            <input v-model="form.paperName" class="form-control" placeholder="请输入试卷名称" />
          </div>
          <div class="paper-form-item">
            <label class="paper-form-label">总分：</label>
            <input v-model.number="form.totalScore" type="number" class="form-control" placeholder="请输入总分" />
          </div>
          <div class="paper-form-item">
            <label class="paper-form-label">考试时长(分钟)：</label>
            <input v-model.number="form.examDuration" type="number" class="form-control" placeholder="请输入考试时长" />
          </div>
          <div class="paper-form-item">
            <label class="paper-form-label">及格分：</label>
            <input v-model.number="form.passScore" type="number" class="form-control" placeholder="请输入及格分" />
          </div>
        </div>

        <div class="paper-form-actions">
          <button class="btn btn-success" @click="createOrUpdatePaper">保存试卷</button>
          <button class="btn btn-warning" @click="clearForm">清空表单</button>
          <button v-if="selectedPaperId" class="btn btn-danger" @click="deletePaper">删除当前试卷</button>
        </div>
      </section>

      <section class="card-box" v-if="activeMenu === 'paper'">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="mb-0">试卷列表</h4>
          <button class="btn btn-light btn-sm" @click="loadPapers">刷新</button>
        </div>
        <div class="result-shell">
          <table class="table table-striped align-middle modern-table mb-0">
            <thead>
              <tr>
                <th>ID</th>
                <th>试卷名称</th>
                <th>总分</th>
                <th>时长(分钟)</th>
                <th>及格分</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in papers" :key="p.id">
                <td>{{ p.id }}</td>
                <td>{{ p.paperName }}</td>
                <td>{{ p.totalScore }}</td>
                <td>{{ p.examDuration }}</td>
                <td>{{ p.passScore }}</td>
                <td>
                  <button class="btn btn-sm btn-light me-2" @click="selectPaper(p.id)">管理题目</button>
                  <button class="btn btn-sm btn-warning me-2" @click="openPaperEditModal(p.id)">编辑</button>
                  <button class="btn btn-sm btn-primary me-2" @click="openPaperParticipantsModal(p)">查看学生</button>
                  <button class="btn btn-sm btn-outline-success" @click="exportPaperParticipants(p.id, p.paperName)">导出学生</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="card-box" v-if="activeMenu === 'paper' && selectedPaperId">
        <h4>组卷配置（固定 / 随机）</h4>

        <div class="card-box-sm mb-3">
          <h5>固定组卷（手动选题）</h5>
          <div class="row g-2 mb-2">
            <div class="col-md-3">
              <input v-model="questionFilters.keyword" class="form-control" placeholder="题干关键词（模糊）" />
            </div>
            <div class="col-md-2">
              <select v-model="questionFilters.type" class="form-select">
                <option value="">全部题型</option>
                <option value="radio">单选</option>
                <option value="multiple">多选</option>
                <option value="coding">编码题</option>
                <option value="material_collect">资料收集</option>
                <option value="scratch">Scratch编程</option>
              </select>
            </div>
            <div class="col-md-2">
              <select v-model="questionFilters.difficulty" class="form-select">
                <option value="">全部难度</option>
                <option value="easy">易</option>
                <option value="middle">中</option>
                <option value="hard">难</option>
              </select>
            </div>
            <div class="col-md-2">
              <select v-model.number="questionFilters.bankId" class="form-select">
                <option :value="null">全部题库</option>
                <option v-for="b in banks" :key="b.id" :value="b.id">{{ b.bankName }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <select v-model.number="questionFilters.tagId" class="form-select">
                <option :value="null">全部标签</option>
                <option v-for="t in tags" :key="t.id" :value="t.id">{{ t.tagName }}</option>
              </select>
            </div>
          </div>
          <div class="d-flex flex-wrap gap-2 mb-2 align-items-center">
            <button class="btn btn-light" @click="loadCandidateQuestions">加载候选题目</button>
            <button class="btn btn-success" @click="saveFixed">保存固定组卷（覆盖整卷）</button>
            <button class="btn btn-outline-primary" type="button" @click="appendCheckedQuestionsToPaper">追加勾选题目到试卷</button>
            <button class="btn btn-light" @click="selectAllCandidateQuestions">全选当前筛选结果</button>
            <span class="small text-muted">已加载 {{ candidateQuestions.length }} 道候选；换题型筛选后勾选再点「追加」可保留卷内已有题目</span>
          </div>

          <div class="candidate-grid">
            <div v-if="candidateQuestions.length === 0" class="text-muted">
              先选择筛选条件并点击“加载候选题目”
            </div>
            <div v-for="q in pagedCandidateQuestions" :key="q.question.id" class="candidate-item">
              <label class="d-flex align-items-start gap-2">
                <input
                  type="checkbox"
                  class="mt-1"
                  :value="q.question.id"
                  v-model="selectedQuestionIds"
                />
                <div>
                  <div class="small">题目ID: {{ q.question.id }} / 题型: {{ questionTypeText(q.question.type) }} / 难度: {{ questionDifficultyText(q.question.difficulty) }} / 分值: {{ q.question.score }}</div>
                  <div class="title-cell">{{ q.question.title }}</div>
                  <div class="small text-muted mt-1">标签：{{ (q.tags || []).join(', ') }}</div>
                </div>
              </label>
            </div>
          </div>
          <div class="d-flex justify-content-end align-items-center gap-2 mt-2" v-if="candidateQuestions.length > 0">
            <button class="btn btn-sm btn-light" :disabled="candidatePage <= 1" @click="candidatePage = candidatePage - 1">上一页</button>
            <span class="small text-muted">第 {{ candidatePage }} / {{ candidateTotalPages }} 页（每页10条）</span>
            <button class="btn btn-sm btn-light" :disabled="candidatePage >= candidateTotalPages" @click="candidatePage = candidatePage + 1">下一页</button>
          </div>
        </div>

        <div class="card-box-sm">
          <h5>随机组卷（按条件抽题）</h5>
          <div class="row g-2 mb-2">
            <div class="col-md-2">
              <input v-model.number="randomForm.count" type="number" class="form-control" placeholder="题目数量" />
            </div>
            <div class="col-md-3">
              <input v-model="randomForm.keyword" class="form-control" placeholder="题干关键词（模糊）" />
            </div>
            <div class="col-md-3">
              <select v-model="randomForm.type" class="form-select">
                <option value="">全部题型</option>
                <option value="radio">单选</option>
                <option value="multiple">多选</option>
                <option value="coding">编码题</option>
                <option value="material_collect">资料收集</option>
                <option value="scratch">Scratch编程</option>
              </select>
            </div>
            <div class="col-md-2">
              <select v-model="randomForm.difficulty" class="form-select">
                <option value="">全部难度</option>
                <option value="easy">易</option>
                <option value="middle">中</option>
                <option value="hard">难</option>
              </select>
            </div>
          </div>
          <div class="row g-2 mb-2">
            <div class="col-md-3">
              <select v-model.number="randomForm.bankId" class="form-select">
                <option :value="null">全部题库</option>
                <option v-for="b in banks" :key="b.id" :value="b.id">{{ b.bankName }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <select v-model.number="randomForm.tagId" class="form-select">
                <option :value="null">全部标签</option>
                <option v-for="t in tags" :key="t.id" :value="t.id">{{ t.tagName }}</option>
              </select>
            </div>
            <div class="col-md-6 d-flex flex-wrap gap-2 align-items-end">
              <button class="btn btn-primary flex-grow-1" type="button" @click="saveRandom">随机抽题（覆盖整卷）</button>
              <button class="btn btn-outline-primary flex-grow-1" type="button" @click="appendRandomQuestionsToPaper">随机抽题并追加</button>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="mb-0">
              当前试卷题目
              <span class="badge text-bg-light ms-2">已组卷 {{ currentPaperQuestionScore }} / 试卷总分 {{ currentPaperTotalScore }}</span>
            </h5>
            <div class="d-flex gap-2 flex-wrap">
              <button class="btn btn-sm btn-outline-danger" @click="batchDeletePaperQuestions">批量删除勾选题目</button>
              <button class="btn btn-sm btn-outline-success" @click="recalcAndSyncPaperTotal">自动重算并同步试卷总分</button>
              <button class="btn btn-sm btn-outline-primary" @click="savePaperQuestionOrder">保存拖拽后的排序</button>
              <button class="btn btn-sm btn-primary" type="button" @click="validatePaperScoresCommit">保存试卷（校验分值）</button>
            </div>
          </div>
          <div class="result-shell">
            <table class="table table-striped align-middle modern-table mb-0 paper-question-table">
              <thead>
                <tr>
                  <th style="width: 80px;">
                    <input type="checkbox" :checked="isAllCurrentPageChecked" @change="toggleCheckAllCurrentPage($event)" />
                  </th>
                  <th class="col-id">题目ID</th>
                  <th class="col-type">题型</th>
                  <th class="col-difficulty">难度</th>
                  <th class="col-title">题干</th>
                  <th class="col-score">分值</th>
                  <th class="col-action">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(pq, idx) in pagedPaperQuestions"
                  :key="pq.id"
                  draggable="true"
                  @dragstart="onPaperQuestionDragStart((paperQuestionPage - 1) * paperQuestionPageSize + idx)"
                  @dragover.prevent
                  @drop="onPaperQuestionDrop((paperQuestionPage - 1) * paperQuestionPageSize + idx)"
                >
                  <td>
                    <input type="checkbox" :value="pq.id" v-model="selectedPaperQuestionIds" />
                  </td>
                  <td>{{ pq.questionId }}</td>
                  <td>{{ questionTypeText(questionDetailMap[pq.questionId] && questionDetailMap[pq.questionId].type) }}</td>
                  <td>{{ questionDifficultyText(questionDetailMap[pq.questionId] && questionDetailMap[pq.questionId].difficulty) }}</td>
                  <td class="title-cell col-title-cell">{{ (questionDetailMap[pq.questionId] && questionDetailMap[pq.questionId].title) || '-' }}</td>
                  <td>
                    <input v-model.number="pq.score" type="number" min="0" class="form-control form-control-sm" style="max-width:120px;" />
                  </td>
                  <td class="action-cell">
                    <div class="d-flex gap-2">
                      <button class="btn btn-sm btn-light" @click="openPaperQuestionEditModal(pq)">查看/编辑题目</button>
                      <button class="btn btn-sm btn-primary" @click="updatePaperQuestion(pq)">保存修改</button>
                      <button class="btn btn-sm btn-danger" @click="deletePaperQuestion(pq)">删除</button>
                    </div>
                  </td>
                </tr>
                <tr v-if="paperQuestions.length === 0">
                  <td colspan="7" class="text-muted">暂无题目</td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-between align-items-center mt-2">
              <div class="small text-muted">已勾选 {{ selectedPaperQuestionIds.length }} 题</div>
              <div class="d-flex align-items-center gap-2">
                <button class="btn btn-sm btn-light" :disabled="paperQuestionPage <= 1" @click="paperQuestionPage = paperQuestionPage - 1">上一页</button>
                <span class="small text-muted">第 {{ paperQuestionPage }} / {{ paperQuestionTotalPages }} 页</span>
                <button class="btn btn-sm btn-light" :disabled="paperQuestionPage >= paperQuestionTotalPages" @click="paperQuestionPage = paperQuestionPage + 1">下一页</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="card-box mt-3" v-if="activeMenu === 'paper'">
        <h4>Excel导入（创建试卷 + 考试 + 题目）</h4>
        <div class="row g-2 mb-2">
          <div class="col-md-8">
            <input type="file" class="form-control" accept=".xlsx" @change="onExcelChange" />
          </div>
          <div class="col-md-4 d-flex align-items-end">
            <button class="btn btn-success w-100" @click="importExcel">导入并创建</button>
          </div>
        </div>
        <div class="small text-muted">
          Excel格式（单个试卷）：第1行元信息（A paperName, B totalScore, C examDuration, D passScore, F examName, G startTime, H endTime, I status, J showAnalysis）。
          从第2行开始：A questionId，B score（可选），C sort（可选）。
        </div>
      </section>

      <section class="card-box" v-if="activeMenu === 'exam'">
        <h4>创建 / 编辑考试</h4>
        <div class="paper-form-grid mb-3">
          <div class="paper-form-item">
            <label class="paper-form-label">考试名称：</label>
            <input v-model="examForm.examName" class="form-control" placeholder="请输入考试名称" />
          </div>
          <div class="paper-form-item">
            <label class="paper-form-label">绑定试卷：</label>
            <select v-model.number="examForm.paperId" class="form-select">
              <option :value="null">请选择试卷</option>
              <option v-for="p in papers" :key="p.id" :value="p.id">{{ p.paperName }}</option>
            </select>
          </div>
          <div class="paper-form-item">
            <label class="paper-form-label">开考时间：</label>
            <input v-model="examForm.startTime" type="datetime-local" class="form-control" />
          </div>
          <div class="paper-form-item">
            <label class="paper-form-label">结束时间：</label>
            <input v-model="examForm.endTime" type="datetime-local" class="form-control" />
          </div>
          <div class="paper-form-item">
            <label class="paper-form-label">解析设置：</label>
            <select v-model.number="examForm.showAnalysis" class="form-select">
              <option :value="1">显示解析</option>
              <option :value="0">不显示解析</option>
            </select>
          </div>
          <div class="paper-form-item">
            <label class="paper-form-label">显示答案：</label>
            <select v-model.number="examForm.showAnswerAfterSubmit" class="form-select">
              <option :value="1">允许学生提交后查看答案与解析</option>
              <option :value="0">提交后不显示答案</option>
            </select>
          </div>
          <div class="paper-form-item">
            <label class="paper-form-label">允许重做：</label>
            <select v-model.number="examForm.allowRedo" class="form-select">
              <option :value="1">允许学生重做试卷</option>
              <option :value="0">不允许重做</option>
            </select>
          </div>
          <div class="paper-form-item">
            <label class="paper-form-label">参考人员ID：</label>
            <input
              v-model="examForm.participantUserIdsText"
              class="form-control"
              placeholder="逗号分隔（例如：1,2,3）"
            />
          </div>
          <div class="paper-form-item">
            <label class="paper-form-label">Excel导入：</label>
            <input type="file" class="form-control" accept=".xlsx" @change="onParticipantExcelChange" />
          </div>
        </div>
        <div class="paper-form-actions mb-2">
          <button class="btn btn-success" @click="saveExam">保存考试</button>
          <button class="btn btn-light" @click="importParticipants">Excel导入参考人员</button>
          <button class="btn btn-light" @click="downloadParticipantTemplate">下载人员模板</button>
          <button class="btn btn-warning" @click="resetExamForm">清空表单</button>
        </div>
      </section>

      <section class="card-box" v-if="activeMenu === 'exam'">
        <h4>考试列表</h4>
        <div class="result-shell">
          <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
            <label class="small text-muted mb-0">每页</label>
            <select v-model.number="examPageSize" class="form-select form-select-sm" style="width: auto" @change="searchExamList">
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="50">50</option>
            </select>
            <span class="small text-muted">
              共 {{ examTotalElements }} 条，第 {{ examPage + 1 }} / {{ examTotalPages }} 页
            </span>
            <button type="button" class="btn btn-sm btn-light ms-auto" :disabled="examLoading" @click="loadExamList">刷新</button>
          </div>
          <table class="table table-striped align-middle modern-table mb-0">
            <thead>
              <tr>
                <th>ID</th>
                <th>考试名称</th>
                <th>试卷</th>
                <th>开始时间</th>
                <th>结束时间</th>
                <th>状态</th>
                <th>解析</th>
                <th>显示答案</th>
                <th>允许重做</th>
                <th>参考人数</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in examList" :key="item.exam.id">
                <td>{{ item.exam.id }}</td>
                <td>{{ item.exam.examName }}</td>
                <td>{{ item.paperName }}</td>
                <td>{{ $fmtDateTime(item.exam.startTime) }}</td>
                <td>{{ $fmtDateTime(item.exam.endTime) }}</td>
                <td>
                  <span class="status-badge" :class="statusClass(item.exam.status)">
                    {{ statusText(item.exam.status) }}
                  </span>
                </td>
                <td>{{ Number(item.showAnalysis) === 0 ? '不显示' : '显示' }}</td>
                <td>{{ Number(item.showAnswerAfterSubmit) === 1 ? '提交后可见' : '关闭' }}</td>
                <td>{{ Number(item.allowRedo) === 1 ? '允许' : '关闭' }}</td>
                <td>{{ item.participantCount || 0 }}</td>
                <td>
                  <button class="btn btn-sm btn-light me-2" @click="openExamEditModal(item)">编辑</button>
                  <button class="btn btn-sm btn-primary me-2" @click="openParticipantManageModal(item)">参考人员</button>
                  <button class="btn btn-sm btn-outline-success me-2" @click="exportParticipantsForExam(item.exam.id, item.exam.examName)">导出学生</button>
                  <button class="btn btn-sm btn-success me-2" @click="publishExam(item.exam.id)">发布</button>
                  <button class="btn btn-sm btn-warning me-2" @click="cancelExam(item.exam.id)">取消</button>
                  <button class="btn btn-sm btn-danger" @click="deleteExam(item.exam.id)">删除</button>
                </td>
              </tr>
              <tr v-if="!examLoading && examList.length === 0">
                <td colspan="11" class="text-muted">暂无考试</td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex flex-wrap justify-content-end align-items-center gap-2 mt-3">
            <button type="button" class="btn btn-sm btn-light" :disabled="examPage <= 0 || examLoading" @click="goExamPage(0)">
              首页
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light"
              :disabled="examPage <= 0 || examLoading"
              @click="goExamPage(examPage - 1)"
            >
              上一页
            </button>
            <span class="small text-muted">{{ examPage + 1 }} / {{ examTotalPages }}</span>
            <button
              type="button"
              class="btn btn-sm btn-light"
              :disabled="examPage >= examTotalPages - 1 || examLoading"
              @click="goExamPage(examPage + 1)"
            >
              下一页
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light"
              :disabled="examPage >= examTotalPages - 1 || examLoading"
              @click="goExamPage(examTotalPages - 1)"
            >
              末页
            </button>
          </div>
        </div>
      </section>

      <section class="card-box" v-if="activeMenu === 'grading'">
        <h4>阅卷管理</h4>
        <div class="row g-2 mb-3">
          <div class="col-md-4">
            <select v-model.number="gradingExamId" class="form-select" @change="loadGradingRecords">
              <option :value="null">请选择考试</option>
              <option v-for="item in examSelectList" :key="`g-exam-${item.exam.id}`" :value="item.exam.id">
                {{ item.exam.examName }} (ID: {{ item.exam.id }})
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <button class="btn btn-light w-100" @click="loadGradingRecords">查询</button>
          </div>
        </div>
        <div class="d-flex gap-2 mb-3">
          <button class="btn" :class="gradingStatusFilter === 'pending' ? 'btn-primary' : 'btn-light'" @click="gradingStatusFilter = 'pending'">
            未阅卷
          </button>
          <button class="btn" :class="gradingStatusFilter === 'graded' ? 'btn-primary' : 'btn-light'" @click="gradingStatusFilter = 'graded'">
            已阅卷
          </button>
          <button class="btn" :class="gradingStatusFilter === 'all' ? 'btn-primary' : 'btn-light'" @click="gradingStatusFilter = 'all'">
            全部
          </button>
        </div>
        <div class="form-check mb-3">
          <input id="onlySubmitted" v-model="onlySubmittedForGrading" class="form-check-input" type="checkbox" />
          <label class="form-check-label" for="onlySubmitted">仅看已交卷（有交卷时间）</label>
        </div>
        <div class="row g-2 mb-3">
          <div class="col-md-5">
            <input v-model="gradingUserKeyword" class="form-control" placeholder="按学员账号或ID过滤" />
          </div>
        </div>

        <div class="result-shell">
          <table class="table table-striped align-middle modern-table mb-0">
            <thead>
              <tr>
                <th>recordId</th>
                <th>userId</th>
                <th>账号</th>
                <th>状态</th>
                <th>得分</th>
                <th>交卷时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in filteredGradingRecordRows" :key="`grading-row-${r.recordId}`">
                <td>{{ r.recordId }}</td>
                <td>{{ r.userId }}</td>
                <td>{{ r.username || '-' }}</td>
                <td>{{ gradingStatusText(r.status) }}</td>
                <td>{{ r.score ?? 0 }}</td>
                <td>{{ $fmtDateTime(r.submitTime) }}</td>
                <td>
                  <button class="btn btn-sm btn-primary" @click="goGradingWorkspace(r)">去阅卷</button>
                </td>
              </tr>
              <tr v-if="filteredGradingRecordRows.length === 0">
                <td colspan="7" class="text-muted">暂无可阅卷记录</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </main>

    <div v-if="showPaperEditModal" class="modal-mask" @click.self="closePaperEditModal">
      <div class="modal-panel">
        <h5 class="mb-3">编辑试卷</h5>
        <div class="row g-2">
          <div class="col-md-6">
            <label class="form-label">试卷名称</label>
            <input v-model="paperEditForm.paperName" class="form-control" />
          </div>
          <div class="col-md-2">
            <label class="form-label">总分</label>
            <input v-model.number="paperEditForm.totalScore" type="number" class="form-control" />
          </div>
          <div class="col-md-2">
            <label class="form-label">时长(分钟)</label>
            <input v-model.number="paperEditForm.examDuration" type="number" class="form-control" />
          </div>
          <div class="col-md-2">
            <label class="form-label">及格分</label>
            <input v-model.number="paperEditForm.passScore" type="number" class="form-control" />
          </div>
        </div>
        <p class="small text-muted mt-2 mb-0">开考/结束时间与是否显示解析请到「考试管理」中设置。</p>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button class="btn btn-light" @click="closePaperEditModal">取消</button>
          <button class="btn btn-primary" @click="savePaperEdit">保存修改</button>
        </div>
      </div>
    </div>

    <div v-if="showExamEditModal" class="modal-mask" @click.self="closeExamEditModal">
      <div class="modal-panel">
        <h5 class="mb-3">编辑考试</h5>
        <div class="row g-2">
          <div class="col-md-4">
            <label class="form-label">考试名称</label>
            <input v-model="examEditForm.examName" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label">绑定试卷</label>
            <select v-model.number="examEditForm.paperId" class="form-select">
              <option :value="null">绑定试卷</option>
              <option v-for="p in papers" :key="`ep-${p.id}`" :value="p.id">{{ p.paperName }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label">开始时间</label>
            <input v-model="examEditForm.startTime" type="datetime-local" class="form-control" />
          </div>
          <div class="col-md-2">
            <label class="form-label">结束时间</label>
            <input v-model="examEditForm.endTime" type="datetime-local" class="form-control" />
          </div>
          <div class="col-md-2">
            <label class="form-label">解析设置</label>
            <select v-model.number="examEditForm.showAnalysis" class="form-select">
              <option :value="1">显示解析</option>
              <option :value="0">不显示解析</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label">显示答案</label>
            <select v-model.number="examEditForm.showAnswerAfterSubmit" class="form-select">
              <option :value="1">允许提交后查看</option>
              <option :value="0">提交后不显示</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label">允许重做</label>
            <select v-model.number="examEditForm.allowRedo" class="form-select">
              <option :value="1">允许学生重做</option>
              <option :value="0">不允许重做</option>
            </select>
          </div>
          <div class="col-md-1">
            <label class="form-label">状态</label>
            <select v-model="examEditForm.status" class="form-select">
              <option value="NOT_START">未开始</option>
              <option value="ING">进行中</option>
              <option value="END">已结束</option>
            </select>
          </div>
          <div class="col-md-12">
            <label class="form-label">参考人员ID（逗号分隔）</label>
            <input v-model="examEditForm.participantUserIdsText" class="form-control" />
          </div>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button class="btn btn-light" @click="closeExamEditModal">取消</button>
          <button class="btn btn-primary" @click="saveExamEdit">保存修改</button>
        </div>
      </div>
    </div>

    <div v-if="showParticipantManageModal" class="modal-mask" @click.self="closeParticipantManageModal">
      <div class="modal-panel">
        <h5 class="mb-3">参考人员管理</h5>
        <div class="participant-line mb-2">
          <div class="participant-line-label">考试信息：</div>
          <div class="participant-line-content small text-muted">
            {{ participantManageExam.examName || '-' }} (ID: {{ participantManageExam.id || '-' }})
          </div>
        </div>

        <div class="participant-line mb-2">
          <div class="participant-line-label">批量新增人员ID：</div>
          <div class="participant-line-content">
            <input
              v-model="participantDraftText"
              class="form-control participant-input"
              placeholder="输入要新增的用户ID，逗号分隔（例如：1,2,3）"
            />
          </div>
        </div>
        <div class="participant-line mb-2">
          <div class="participant-line-label">文本新增：</div>
          <div class="participant-line-content">
            <button class="btn btn-primary participant-btn" @click="appendParticipantsByText">批量新增到列表</button>
          </div>
        </div>

        <div class="participant-line mb-2">
          <div class="participant-line-label">选择Excel文件：</div>
          <div class="participant-line-content">
            <input type="file" class="form-control form-control-sm participant-file-input" accept=".xlsx" @change="onManageParticipantExcelChange" />
          </div>
        </div>
        <div class="participant-line mb-2">
          <div class="participant-line-label">Excel新增：</div>
          <div class="participant-line-content">
            <button class="btn btn-light participant-btn" @click="importParticipantsForManage">Excel批量新增到列表</button>
          </div>
        </div>
        <div class="participant-line mb-2">
          <div class="participant-line-label">模板下载：</div>
          <div class="participant-line-content">
            <button class="btn btn-light participant-btn" @click="downloadParticipantTemplate">下载批量新增人员Excel模板</button>
          </div>
        </div>
        <div class="participant-line mb-3">
          <div class="participant-line-label">模板说明：</div>
          <div class="participant-line-content small text-muted">
            账号模板：从第2行开始填写 A 列「账号」。准考证模板：A 准考证号（必填）、B 姓名、C 手机号；按准考证绑定学生并可自动建号后加入参考名单。Automan 模板：A 列「手机号或账号」，导入时自动同步考试学员账号。
          </div>
        </div>

        <div class="card-box-sm mb-3 ticket-assign-box">
          <h6 class="mb-2">按准考证维度分配试卷</h6>
          <div class="participant-line mb-2">
            <div class="participant-line-label">准考证号文本：</div>
            <div class="participant-line-content">
              <textarea
                v-model="participantTicketDraftText"
                class="form-control participant-input"
                rows="2"
                placeholder="输入准考证号，逗号或换行分隔"
              />
            </div>
          </div>
          <div class="participant-line mb-2">
            <div class="participant-line-label">文本绑定：</div>
            <div class="participant-line-content">
              <button class="btn btn-primary participant-btn" type="button" @click="appendParticipantsByTicketText">
                按准考证绑定到列表
              </button>
            </div>
          </div>
          <div class="participant-line mb-2">
            <div class="participant-line-label">准考证Excel：</div>
            <div class="participant-line-content">
              <input
                type="file"
                class="form-control form-control-sm participant-file-input"
                accept=".xlsx"
                @change="onManageParticipantTicketExcelChange"
              />
            </div>
          </div>
          <div class="participant-line mb-2">
            <div class="participant-line-label">Excel绑定：</div>
            <div class="participant-line-content d-flex flex-wrap gap-2">
              <button class="btn btn-light participant-btn" type="button" @click="importParticipantsByTicketForManage">
                Excel按准考证批量绑定
              </button>
              <button class="btn btn-light participant-btn" type="button" @click="downloadParticipantTicketTemplate">
                下载准考证导入模板
              </button>
            </div>
          </div>
          <div class="small text-muted">
            导入后自动按准考证绑定/创建学生，再点击「保存参考人员」即可完成试卷定向分配。
          </div>
        </div>

        <div class="card-box-sm mb-3 ticket-assign-box">
          <h6 class="mb-2">从 Automan 导入参考人员</h6>
          <div class="participant-line mb-2">
            <div class="participant-line-label">手机号/账号：</div>
            <div class="participant-line-content">
              <textarea
                v-model="participantAutomanDraftText"
                class="form-control participant-input"
                rows="2"
                placeholder="输入 Automan 手机号或账号，逗号或换行分隔"
              />
            </div>
          </div>
          <div class="participant-line mb-2">
            <div class="participant-line-label">文本导入：</div>
            <div class="participant-line-content">
              <button class="btn btn-primary participant-btn" type="button" @click="appendParticipantsByAutomanText">
                从 Automan 解析到列表
              </button>
            </div>
          </div>
          <div class="participant-line mb-2">
            <div class="participant-line-label">Automan Excel：</div>
            <div class="participant-line-content">
              <input
                type="file"
                class="form-control form-control-sm participant-file-input"
                accept=".xlsx"
                @change="onManageParticipantAutomanExcelChange"
              />
            </div>
          </div>
          <div class="participant-line mb-2">
            <div class="participant-line-label">Excel导入：</div>
            <div class="participant-line-content d-flex flex-wrap gap-2">
              <button class="btn btn-light participant-btn" type="button" @click="importParticipantsByAutomanForManage">
                Excel从 Automan 批量导入
              </button>
              <button class="btn btn-light participant-btn" type="button" @click="downloadParticipantAutomanTemplate">
                下载 Automan 导入模板
              </button>
            </div>
          </div>
          <div class="small text-muted">
            按 Automan 手机号或账号查询并同步为考试学员账号，再点击「保存参考人员」完成分配。
          </div>
        </div>

        <div class="card-box-sm mb-3">
          <h6 class="mb-2">按账号/姓名/ID范围搜索并添加</h6>
          <div class="row g-2 mb-2">
            <div class="col-md-2">
              <input
                v-model="userSearchIdFrom"
                type="number"
                min="1"
                class="form-control"
                placeholder="学生ID起"
                @keyup.enter="searchStudentUsers(0)"
              />
            </div>
            <div class="col-md-2">
              <input
                v-model="userSearchIdTo"
                type="number"
                min="1"
                class="form-control"
                placeholder="学生ID止"
                @keyup.enter="searchStudentUsers(0)"
              />
            </div>
            <div class="col-md-2">
              <input
                v-model="userSearchUsername"
                class="form-control"
                placeholder="账号（模糊）"
                @keyup.enter="searchStudentUsers(0)"
              />
            </div>
            <div class="col-md-2">
              <input
                v-model="userSearchRealName"
                class="form-control"
                placeholder="姓名（模糊）"
                @keyup.enter="searchStudentUsers(0)"
              />
            </div>
            <div class="col-md-2">
              <input
                v-model="userSearchKeyword"
                class="form-control"
                placeholder="综合：手机/准考证/ID"
                @keyup.enter="searchStudentUsers(0)"
              />
            </div>
            <div class="col-md-2 d-grid">
              <button class="btn btn-light" type="button" @click="searchStudentUsers(0)">查询</button>
            </div>
          </div>
          <div class="d-flex flex-wrap align-items-center gap-3 mb-2">
            <div class="form-check mb-0">
              <input id="hideAddedUsers" v-model="hideAddedUsersInSearch" class="form-check-input" type="checkbox" @change="searchStudentUsers(0)" />
              <label class="form-check-label" for="hideAddedUsers">仅显示未加入参考名单的学员</label>
            </div>
            <span class="small text-muted">
              筛选结果共 <strong>{{ userSearchTotalElements }}</strong> 人
              <template v-if="userSearchTicketExtra > 0">（另含未建号准考证 {{ userSearchTicketExtra }} 条）</template>
              ，第 {{ userSearchPage + 1 }} / {{ userSearchTotalPages }} 页
            </span>
            <select v-model.number="userSearchPageSize" class="form-select form-select-sm" style="width: auto;" @change="searchStudentUsers(0)">
              <option :value="10">每页 10</option>
              <option :value="20">每页 20</option>
              <option :value="50">每页 50</option>
              <option :value="100">每页 100</option>
            </select>
            <div class="btn-group btn-group-sm">
              <button type="button" class="btn btn-outline-secondary" :disabled="userSearchPage <= 0 || userSearchLoading" @click="searchStudentUsers(userSearchPage - 1)">上一页</button>
              <button type="button" class="btn btn-outline-secondary" :disabled="userSearchPage + 1 >= userSearchTotalPages || userSearchLoading" @click="searchStudentUsers(userSearchPage + 1)">下一页</button>
            </div>
          </div>
          <div class="small text-muted mb-2">
            独立批量生成、尚未登录的准考证会出现在结果中（状态：未建号）。勾选后添加时会自动建号并绑定，无需学生先登录。
          </div>
          <div class="result-shell">
            <table class="table table-striped align-middle modern-table mb-0">
              <thead>
                <tr>
                  <th style="width: 46px;">
                    <input type="checkbox" :checked="isAllSearchUsersChecked" @change="toggleAllSearchUsers($event)" />
                  </th>
                  <th>ID</th>
                  <th>账号</th>
                  <th>姓名</th>
                  <th>准考证</th>
                  <th>手机号</th>
                  <th>状态</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="userSearchLoading">
                  <td colspan="7" class="text-muted">查询中…</td>
                </tr>
                <tr v-for="u in filteredUserSearchRows" :key="u.selectionKey || u.id || u.ticketNo">
                  <td>
                    <input
                      type="checkbox"
                      :value="u.selectionKey || ('u:' + u.id)"
                      v-model="selectedSearchUserIds"
                    />
                  </td>
                  <td>{{ u.id || '-' }}</td>
                  <td>{{ u.username || '-' }}</td>
                  <td>{{ u.realName || '-' }}</td>
                  <td>{{ u.ticketNo || '-' }}</td>
                  <td>{{ u.phone || '-' }}</td>
                  <td>
                    <span v-if="u.unbound || u.fromTicketInventory" class="text-warning">未建号</span>
                    <span v-else class="text-muted">已建号</span>
                  </td>
                </tr>
                <tr v-if="!userSearchLoading && filteredUserSearchRows.length === 0">
                  <td colspan="7" class="text-muted">暂无查询结果（共 {{ userSearchTotalElements }} 人匹配筛选条件）</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-2 flex-wrap gap-2">
            <span class="small text-muted">本页显示 {{ filteredUserSearchRows.length }} 人，已勾选 {{ selectedSearchUserIds.length }} 人</span>
            <button class="btn btn-primary" @click="appendSelectedSearchUsers">添加勾选学员到参考人员</button>
          </div>
        </div>

        <div class="d-flex gap-2 mb-2 flex-wrap">
          <button class="btn btn-warning" @click="batchRemoveParticipants">批量删除已选</button>
          <button class="btn btn-danger" @click="clearAllParticipants">清空全部</button>
          <button class="btn btn-light" @click="loadParticipantRecords(participantManageExam.id)">刷新人员信息</button>
          <button class="btn btn-success" :disabled="!participantManageExam.id" @click="exportParticipants">导出学生名单</button>
        </div>

        <div v-if="examImporterSummary.length" class="alert alert-light border py-2 px-3 mb-2 small">
          <div class="fw-semibold mb-1">导入人汇总</div>
          <div class="d-flex flex-wrap gap-2">
            <span v-for="item in examImporterSummary" :key="'eis-' + item.name" class="badge text-bg-secondary">
              {{ item.name }}：{{ item.count }} 人
            </span>
          </div>
        </div>
        <div class="small text-muted mb-2">说明：导入教师仅对「本功能上线后新加入」的学生有记录；历史数据可能显示为「-」。</div>

        <div class="result-shell">
          <table class="table table-striped align-middle modern-table mb-0">
            <thead>
              <tr>
                <th style="width: 46px;">
                  <input type="checkbox" :checked="isAllParticipantsChecked" @change="toggleAllParticipants($event)" />
                </th>
                <th>记录ID</th>
                <th>用户ID</th>
                <th>账号</th>
                <th>姓名</th>
                <th>状态</th>
                <th>得分</th>
                <th>交卷时间</th>
                <th>导入教师</th>
                <th>导入时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in participantRecords" :key="r.userId">
                <td><input type="checkbox" :value="r.userId" v-model="selectedParticipantIds" /></td>
                <td>{{ r.recordId || '-' }}</td>
                <td>{{ r.userId }}</td>
                <td>{{ r.username || '-' }}</td>
                <td>{{ r.realName || '-' }}</td>
                <td>{{ gradingStatusText(r.status) }}</td>
                <td>{{ r.score ?? 0 }}</td>
                <td>{{ $fmtDateTime(r.submitTime) }}</td>
                <td>{{ r.assignedByName || (r.assignedBy ? ('ID:' + r.assignedBy) : '-') }}</td>
                <td>{{ $fmtDateTime(r.assignedAt) }}</td>
                <td>
                  <button class="btn btn-sm btn-light" :disabled="!r.recordId" @click="goGradingWorkspace(r)">阅卷</button>
                </td>
              </tr>
              <tr v-if="participantRecords.length === 0">
                <td colspan="11" class="text-muted">暂无参考人员</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-3">
          <button class="btn btn-light" @click="closeParticipantManageModal">取消</button>
          <button class="btn btn-success" @click="saveParticipantChanges">保存人员变更到数据库</button>
        </div>
      </div>
    </div>

    <div v-if="showPaperParticipantsModal" class="modal-mask" @click.self="closePaperParticipantsModal">
      <div class="modal-panel modal-wide">
        <h5 class="mb-2">试卷学生名单 · {{ paperParticipantsMeta.paperName || '-' }}</h5>
        <div class="small text-muted mb-2">
          试卷ID：{{ paperParticipantsMeta.paperId || '-' }} /
          关联考试：{{ paperParticipantsMeta.examCount || 0 }} 场 /
          参考人次：{{ paperParticipantsMeta.participantCount || 0 }} /
          去重学生：{{ paperParticipantsMeta.uniqueStudentCount || 0 }}
        </div>
        <div class="small text-muted mb-3">说明：导入教师仅对「本功能上线后新加入」的学生有记录；历史数据可能显示为「-」。</div>
        <div v-if="paperImporterSummary.length" class="alert alert-light border py-2 px-3 mb-2 small">
          <div class="fw-semibold mb-1">导入人汇总</div>
          <div class="d-flex flex-wrap gap-2">
            <span v-for="item in paperImporterSummary" :key="'pis-' + item.name" class="badge text-bg-secondary">
              {{ item.name }}：{{ item.count }} 人
            </span>
          </div>
        </div>
        <div class="d-flex gap-2 mb-2 flex-wrap">
          <button class="btn btn-light" :disabled="paperParticipantsLoading" @click="loadPaperParticipants(paperParticipantsMeta.paperId)">
            {{ paperParticipantsLoading ? '刷新中…' : '刷新' }}
          </button>
          <button class="btn btn-success" :disabled="!paperParticipantsMeta.paperId" @click="exportPaperParticipants(paperParticipantsMeta.paperId, paperParticipantsMeta.paperName)">
            导出学生名单
          </button>
          <button class="btn btn-light" @click="closePaperParticipantsModal">关闭</button>
        </div>
        <div class="result-shell">
          <table class="table table-striped align-middle modern-table mb-0">
            <thead>
              <tr>
                <th>考试ID</th>
                <th>考试名称</th>
                <th>用户ID</th>
                <th>账号</th>
                <th>姓名</th>
                <th>准考证</th>
                <th>状态</th>
                <th>导入教师</th>
                <th>导入时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, idx) in paperParticipantRows" :key="'pp-' + idx + '-' + r.userId">
                <td>{{ r.examId || '-' }}</td>
                <td>{{ r.examName || '-' }}</td>
                <td>{{ r.userId }}</td>
                <td>{{ r.username || '-' }}</td>
                <td>{{ r.realName || '-' }}</td>
                <td>{{ r.ticketNo || '-' }}</td>
                <td>{{ gradingStatusText(r.status) }}</td>
                <td>{{ r.assignedByName || (r.assignedBy ? ('ID:' + r.assignedBy) : '-') }}</td>
                <td>{{ $fmtDateTime(r.assignedAt) }}</td>
              </tr>
              <tr v-if="!paperParticipantsLoading && paperParticipantRows.length === 0">
                <td colspan="9" class="text-muted">该试卷关联考试下暂无参考学生</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="showGradingModal" class="modal-mask" @click.self="closeGradingModal">
      <div class="modal-panel modal-wide">
        <h5 class="mb-2">阅卷（自动 + 手动）</h5>
        <div class="small text-muted mb-2">
          记录ID：{{ gradingRecord.recordId || '-' }} / 学员：{{ gradingRecord.username || '-' }} / 当前总分：{{ gradingRecord.score ?? 0 }}
        </div>
        <div class="result-shell">
          <table class="table table-striped align-middle modern-table mb-0">
            <thead>
              <tr>
                <th>序号</th>
                <th>题型</th>
                <th>题目</th>
                <th>学生作答</th>
                <th>正确答案</th>
                <th>满分</th>
                <th>自动得分</th>
                <th>手动评分</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in gradingRows" :key="row.questionId">
                <td>{{ row.sort }}</td>
                <td>{{ row.typeText || row.type }}</td>
                <td class="title-cell">{{ row.title || '-' }}</td>
                <td class="title-cell">{{ row.userAnswer || '-' }}</td>
                <td class="title-cell">{{ row.correctAnswer || '-' }}</td>
                <td>{{ row.maxScore ?? 0 }}</td>
                <td>{{ row.answerScore ?? 0 }}</td>
                <td>
                  <input
                    v-if="isManualType(row.type)"
                    v-model.number="manualScoreDraft[row.questionId]"
                    type="number"
                    min="0"
                    :max="row.maxScore ?? 0"
                    class="form-control form-control-sm"
                  />
                  <span v-else class="text-muted">自动阅卷</span>
                </td>
              </tr>
              <tr v-if="gradingRows.length === 0">
                <td colspan="8" class="text-muted">暂无可阅卷数据</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div class="small">
            预估总分：<strong>{{ previewGradingTotal }}</strong>
          </div>
          <div class="d-flex gap-2">
            <button class="btn btn-light" @click="closeGradingModal">取消</button>
            <button class="btn btn-success" @click="submitGrading">提交阅卷并实时计算</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showPaperQuestionEditModal" class="modal-mask" @click.self="closePaperQuestionEditModal">
      <div class="modal-panel modal-wide">
        <h5 class="mb-3">查看/编辑题目信息</h5>
        <div class="row g-2">
          <div class="col-md-4">
            <label class="form-label">题库</label>
            <select v-model.number="editingPaperQuestion.bankId" class="form-select">
              <option :value="null">选择题库</option>
              <option v-for="b in banks" :key="`paper-edit-bank-${b.id}`" :value="b.id">{{ b.bankName }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label">题型</label>
            <select v-model="editingPaperQuestion.type" class="form-select" @change="onPaperQuestionTypeChange">
              <option value="radio">单选</option>
              <option value="multiple">多选</option>
              <option value="judge">判断</option>
              <option value="fill">填空</option>
              <option value="essay">简答</option>
              <option value="coding">编码题</option>
              <option value="material_collect">资料收集</option>
              <option value="scratch">Scratch编程</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label">难度</label>
            <select v-model="editingPaperQuestion.difficulty" class="form-select">
              <option value="easy">易</option>
              <option value="middle">中</option>
              <option value="hard">难</option>
            </select>
          </div>
          <div class="col-md-12">
            <label class="form-label">题干</label>
            <textarea v-model="editingPaperQuestion.title" class="form-control" rows="6" placeholder="题干（支持换行，与学生端展示一致）"></textarea>
          </div>
          <div class="col-md-12">
            <div class="qimg-block rounded p-2 mb-2" style="background: rgba(255, 255, 255, 0.55); border: 1px solid #dfe9ff">
              <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
                <span class="form-label mb-0 fw-semibold">题干附图</span>
                <label class="btn btn-sm btn-outline-secondary mb-0">
                  上传图片
                  <input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="onPaperEditStemUpload" />
                </label>
                <span class="small text-muted">jpg/png/gif，≤5MB</span>
              </div>
              <div class="d-flex flex-wrap gap-2 align-items-start">
                <div v-for="(u, idx) in editingPaperQuestion.contentImages || []" :key="'pq-stem-' + idx" class="qimg-tile text-center">
                  <img :src="u" class="teacher-q-thumb" alt="" @click="paperEditImgLightbox = u" />
                  <div class="d-flex gap-2 justify-content-center align-items-center flex-wrap">
                    <label class="btn btn-link btn-sm p-0 mb-0">
                      更换图片
                      <input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e) => onPaperEditStemReplace(e, idx)" />
                    </label>
                    <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="editingPaperQuestion.contentImages.splice(idx, 1)">移除</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isChoiceType(editingPaperQuestion.type)" class="col-md-12">
            <label class="form-label">选项 A（支持换行）</label>
            <textarea v-model="editingChoiceOptions.A" class="form-control mb-2" rows="3"></textarea>
            <label class="form-label">选项 B（支持换行）</label>
            <textarea v-model="editingChoiceOptions.B" class="form-control mb-2" rows="3"></textarea>
            <label class="form-label">选项 C（支持换行）</label>
            <textarea v-model="editingChoiceOptions.C" class="form-control mb-2" rows="3"></textarea>
            <label class="form-label">选项 D（支持换行）</label>
            <textarea v-model="editingChoiceOptions.D" class="form-control" rows="3"></textarea>
          </div>
          <div v-if="isChoiceType(editingPaperQuestion.type)" class="col-md-12">
            <div class="small fw-semibold mb-2">选项附图</div>
            <div class="row g-2">
              <div class="col-md-6" v-for="optKey of paperEditOptionLetters" :key="'pq-opt-' + optKey">
                <div class="small text-muted mb-1">选项 {{ optKey }}</div>
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <label class="btn btn-sm btn-outline-secondary mb-0">
                    上传/更换
                    <input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e) => onPaperEditOptImg(e, optKey)" />
                  </label>
                  <template v-if="paperEditOptionImg(optKey)">
                    <img :src="paperEditOptionImg(optKey)" class="teacher-q-thumb" alt="" @click="paperEditImgLightbox = paperEditOptionImg(optKey)" />
                    <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="paperEditClearOptionImg(optKey)">清除</button>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="col-md-12">
            <label class="form-label">选项或说明（可选）</label>
            <textarea v-model="editingPaperQuestion.options" class="form-control" rows="3" placeholder="判断题、填空说明等；如需结构化存储可保持原有内容"></textarea>
          </div>
          <div class="col-md-12">
            <label class="form-label">答案</label>
            <textarea v-model="editingPaperQuestion.answer" class="form-control" rows="3"></textarea>
          </div>
          <div class="col-md-12">
            <label class="form-label">解析</label>
            <textarea v-model="editingPaperQuestion.analysis" class="form-control" rows="3"></textarea>
          </div>
          <div class="col-md-12">
            <div class="qimg-block rounded p-2 mb-2" style="background: rgba(255, 255, 255, 0.55); border: 1px solid #dfe9ff">
              <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
                <span class="form-label mb-0 fw-semibold">解析附图</span>
                <label class="btn btn-sm btn-outline-secondary mb-0">
                  上传图片
                  <input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="onPaperEditAnalysisUpload" />
                </label>
              </div>
              <div class="d-flex flex-wrap gap-2 align-items-start">
                <div v-for="(u, j) in editingPaperQuestion.analysisImages || []" :key="'pq-ana-' + j" class="qimg-tile text-center">
                  <img :src="u" class="teacher-q-thumb" alt="" @click="paperEditImgLightbox = u" />
                  <div class="d-flex gap-2 justify-content-center align-items-center flex-wrap">
                    <label class="btn btn-link btn-sm p-0 mb-0">
                      更换图片
                      <input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e) => onPaperEditAnalysisReplace(e, j)" />
                    </label>
                    <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="editingPaperQuestion.analysisImages.splice(j, 1)">移除</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">题目分值</label>
            <input v-model.number="editingPaperQuestion.score" type="number" min="0" class="form-control" />
          </div>
          <div class="col-md-9">
            <label class="form-label">标签</label>
            <div class="d-flex flex-wrap gap-2 modal-tag-list">
              <label class="badge bg-secondary p-2" v-for="t in tags" :key="`paper-edit-tag-${t.id}`">
                <input type="checkbox" class="form-check-input me-1" :value="t.id" v-model="editingPaperQuestion.tagIds" />
                {{ t.tagName }}
              </label>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button class="btn btn-light" @click="closePaperQuestionEditModal">取消</button>
          <button class="btn btn-primary" @click="savePaperQuestionEditModal">保存题目修改</button>
        </div>
      </div>
    </div>

    <div v-if="paperEditImgLightbox" class="modal-mask" style="z-index: 1400" @click.self="paperEditImgLightbox = null">
      <div class="bg-white p-3 rounded shadow-lg" style="max-width: min(96vw, 900px)" @click.stop>
        <div class="d-flex justify-content-between mb-2">
          <span class="small text-muted">点击背景关闭</span>
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="paperEditImgLightbox = null">关闭</button>
        </div>
        <img :src="paperEditImgLightbox" alt="预览" style="max-width: 100%; height: auto; max-height: 80vh; object-fit: contain" />
      </div>
    </div>
  </div>
</template>

<script>
import { appConfirm } from '../utils/appDialog'
import { parseUrlList } from '../utils/questionRichMedia'

export default {
  name: 'TeacherPaperManageView',
  data() {
    return {
      activeMenu: localStorage.getItem('teacher_active_menu') || 'paper',
      sidebarCollapsed: false,
      currentUser: {},
      papers: [],
      selectedPaperId: null,
      selectedExamId: null,
      selectedExamConfigId: null,
      paperQuestions: [],
      questionDetailMap: {},
      exams: [],
      examConfigs: [],
      banks: [],
      tags: [],

      form: this.makeEmptyForm(),
      questionFilters: {
        keyword: '',
        type: '',
        difficulty: '',
        bankId: null,
        tagId: null
      },
      candidateQuestions: [],
      selectedQuestionIds: [],
      candidatePage: 1,
      candidatePageSize: 10,

      randomForm: {
        count: 5,
        keyword: '',
        type: '',
        difficulty: '',
        bankId: null,
        tagId: null
      },
      excelFile: null,
      examList: [],
      examSelectList: [],
      examPage: 0,
      examPageSize: 10,
      examTotalPages: 1,
      examTotalElements: 0,
      examLoading: false,
      selectedExamManageId: null,
      participantExcelFile: null,
      participantManageExcelFile: null,
      showPaperEditModal: false,
      showExamEditModal: false,
      showParticipantManageModal: false,
      showPaperParticipantsModal: false,
      paperParticipantsLoading: false,
      paperParticipantRows: [],
      paperParticipantsMeta: {
        paperId: null,
        paperName: '',
        examCount: 0,
        participantCount: 0,
        uniqueStudentCount: 0
      },
      showGradingModal: false,
      showPaperQuestionEditModal: false,
      paperEditForm: {
        id: null,
        paperName: '',
        totalScore: 100,
        examDuration: 60,
        passScore: 60
      },
      examEditForm: {
        id: null,
        examName: '',
        paperId: null,
        startTime: '',
        endTime: '',
        status: 'NOT_START',
        showAnalysis: 1,
        showAnswerAfterSubmit: 0,
        allowRedo: 0,
        participantUserIdsText: ''
      },
      participantManageExam: {
        id: null,
        examName: '',
        paperId: null,
        startTime: '',
        endTime: ''
      },
      participantRecords: [],
      selectedParticipantIds: [],
      participantDraftText: '',
      participantTicketDraftText: '',
      participantManageTicketExcelFile: null,
      participantAutomanDraftText: '',
      participantManageAutomanExcelFile: null,
      userSearchKeyword: '',
      userSearchUsername: '',
      userSearchRealName: '',
      userSearchIdFrom: '',
      userSearchIdTo: '',
      userSearchRows: [],
      userSearchPage: 0,
      userSearchPageSize: 20,
      userSearchTotalElements: 0,
      userSearchTotalPages: 1,
      userSearchTicketExtra: 0,
      userSearchLoading: false,
      selectedSearchUserIds: [],
      hideAddedUsersInSearch: true,
      gradingRecord: { recordId: null, userId: null, username: '', score: 0 },
      gradingRows: [],
      manualScoreDraft: {},
      gradingExamId: null,
      gradingRecordRows: [],
      gradingStatusFilter: 'pending',
      onlySubmittedForGrading: true,
      gradingUserKeyword: '',
      dragPaperQuestionIndex: null,
      editingPaperQuestionId: null,
      editingPaperQuestion: {
        bankId: null,
        type: 'radio',
        title: '',
        options: '',
        answer: '',
        analysis: '',
        difficulty: 'middle',
        score: 5,
        tagIds: [],
        contentImages: [],
        analysisImages: [],
        optionAImage: '',
        optionBImage: '',
        optionCImage: '',
        optionDImage: ''
      },
      paperEditImgLightbox: null,
      editingChoiceOptions: {
        A: '',
        B: '',
        C: '',
        D: ''
      },
      selectedPaperQuestionIds: [],
      paperQuestionPage: 1,
      paperQuestionPageSize: 10,
      examForm: {
        examName: '',
        paperId: null,
        startTime: '',
        endTime: '',
        showAnalysis: 1,
        showAnswerAfterSubmit: 0,
        allowRedo: 0,
        participantUserIdsText: ''
      }
    }
  },
  created() {
    this.currentUser = JSON.parse(localStorage.getItem('exam_user') || '{}')
    if (this.activeMenu !== 'paper' && this.activeMenu !== 'exam' && this.activeMenu !== 'grading') {
      this.activeMenu = 'paper'
    }
    this.loadAll()
    if (this.activeMenu === 'grading') {
      this.loadExamSelectList().then(() => {
        if (this.gradingExamId) this.loadGradingRecords()
      })
    } else {
      this.loadExamList()
    }
  },
  methods: {
    setActiveMenu(menu) {
      this.activeMenu = menu
      localStorage.setItem('teacher_active_menu', menu)
      if (menu === 'exam') this.loadExamList()
      if (menu === 'grading') {
        this.loadExamSelectList().then(() => {
          if (this.gradingExamId) this.loadGradingRecords()
        })
      }
    },
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },
    makeEmptyForm() {
      return {
        paperName: '',
        totalScore: 100,
        examDuration: 60,
        passScore: 60
      }
    },
    authHeaders(extra = {}) {
      let role = 'teacher'
      let userId = ''
      try {
        const u = JSON.parse(localStorage.getItem('exam_user') || '{}')
        role = u.role || 'teacher'
        userId = u.id != null ? String(u.id) : ''
      } catch (e) {
        role = 'teacher'
      }
      return {
        'X-Role': role,
        'X-User-Id': userId,
        'X-CSRF-Token': role === 'admin' ? 'exam-ui' : 'teacher-ui',
        ...extra
      }
    },
    goQuestionManage() {
      localStorage.setItem('teacher_active_menu', 'paper')
      window.location.hash = '#/teacher/questions'
    },
    goExamRecordManage() {
      window.location.hash = '#/teacher/exam-records'
    },
    goProctor() {
      window.location.hash = '#/teacher/proctor'
    },
    goStudentUsers() {
      window.location.hash = '#/teacher/students'
    },
    logout() {
      localStorage.removeItem('exam_user')
      window.location.hash = '#/'
    },
    loadAll() {
      this.loadPapers()
      this.loadExamsAndConfigs()
      this.loadBanks()
      this.loadTags()
    },
    parseExamListPage(res) {
      const data = res && res.data
      if (Array.isArray(data)) {
        return {
          content: data,
          totalElements: data.length,
          totalPages: 1
        }
      }
      return {
        content: (data && data.content) || [],
        totalElements: Number((data && data.totalElements) || 0),
        totalPages: Math.max(1, Number((data && data.totalPages) || 1))
      }
    },
    loadExamList() {
      this.examLoading = true
      const params = new URLSearchParams({
        page: String(this.examPage || 0),
        size: String(this.examPageSize || 10)
      })
      fetch(`/api/teacher/exam-manage/list?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then(async (r) => {
          const res = await r.json().catch(() => ({}))
          if (!r.ok || (res && res.code !== undefined && res.code !== 200)) {
            window.alert((res && res.message) || '加载考试列表失败')
            this.examList = []
            this.examTotalElements = 0
            this.examTotalPages = 1
            return
          }
          const page = this.parseExamListPage(res)
          this.examList = page.content
          this.examTotalElements = page.totalElements
          this.examTotalPages = page.totalPages
          if (this.examPage > this.examTotalPages - 1) {
            this.examPage = Math.max(0, this.examTotalPages - 1)
          }
        })
        .catch(() => {
          window.alert('加载考试列表失败，请检查网络后重试')
          this.examList = []
        })
        .finally(() => {
          this.examLoading = false
        })
    },
    loadExamSelectList() {
      const params = new URLSearchParams({ page: '0', size: '200' })
      return fetch(`/api/teacher/exam-manage/list?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then(async (r) => {
          const res = await r.json().catch(() => ({}))
          if (!r.ok || (res && res.code !== undefined && res.code !== 200)) {
            this.examSelectList = []
            return
          }
          const page = this.parseExamListPage(res)
          this.examSelectList = page.content
          if (!this.gradingExamId && this.examSelectList.length > 0) {
            this.gradingExamId = this.examSelectList[0].exam.id
          }
        })
        .catch(() => {
          this.examSelectList = []
        })
    },
    searchExamList() {
      this.examPage = 0
      this.loadExamList()
    },
    goExamPage(next) {
      const page = Number(next)
      if (!Number.isFinite(page) || page < 0) return
      if (page === this.examPage) return
      if (page >= this.examTotalPages) return
      this.examPage = page
      this.loadExamList()
    },
    loadGradingRecords() {
      if (!this.gradingExamId) {
        this.gradingRecordRows = []
        return
      }
      fetch(`/api/student/exam/answers/exam/${this.gradingExamId}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            this.gradingRecordRows = res.data || []
            return
          }
          this.gradingRecordRows = []
          window.alert(res.message || '加载阅卷记录失败')
        })
    },
    loadPapers() {
      const params = new URLSearchParams({
        page: '0',
        size: '200',
        sortBy: 'id',
        sort: 'desc'
      })
      fetch(`/api/crud/exam-paper?${params.toString()}`)
        .then((r) => r.json())
        .then((res) => {
          this.papers = (res.data && res.data.content) || []
        })
    },
    loadExamsAndConfigs() {
      fetch('/api/crud/exam?page=0&size=500&sortBy=id&sort=desc')
        .then((r) => r.json())
        .then((res) => {
          this.exams = (res.data && res.data.content) || []
        })

      fetch('/api/crud/exam-config?page=0&size=500&sortBy=id&sort=desc')
        .then((r) => r.json())
        .then((res) => {
          this.examConfigs = (res.data && res.data.content) || []
        })
    },
    loadBanks() {
      fetch('/api/teacher/question/banks?page=0&size=200', {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          this.banks = (res.data && res.data.content) || []
        })
    },
    loadTags() {
      fetch('/api/teacher/question/tags', {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          this.tags = res.data || []
        })
    },
    selectPaper(paperId) {
      this.selectedPaperId = paperId
      const exam = this.exams.find((e) => String(e.paperId) === String(paperId)) || null
      this.selectedExamId = exam ? exam.id : null
      const cfg = this.examConfigs.find((c) => String(c.examId) === String(this.selectedExamId)) || null
      this.selectedExamConfigId = cfg ? cfg.id : null
      this.loadPaperQuestions()
    },
    loadPaperQuestions(forceRefresh = false) {
      if (!this.selectedPaperId) return
      const url = forceRefresh
        ? `/api/crud/paper-question/by-paper/${this.selectedPaperId}?_ts=${Date.now()}`
        : `/api/crud/paper-question/by-paper/${this.selectedPaperId}`
      fetch(url, { cache: 'no-store', headers: this.authHeaders() })
        .then((r) => r.json())
        .then((res) => {
          if (res.code !== 200 && typeof res.code !== 'undefined') {
            window.alert(res.message || '加载当前试卷题目失败')
            this.paperQuestions = []
            return
          }
          this.paperQuestions = Array.isArray(res.data)
            ? res.data.map((x) => ({
              ...x,
              score: Number(x.score || 0),
              sort: Number(x.sort || 0)
            }))
            : []
          this.paperQuestions.sort((a, b) => (a.sort || 0) - (b.sort || 0))
          this.loadQuestionDetailsForPaper()
          this.selectedPaperQuestionIds = []
          this.paperQuestionPage = 1
        })
        .catch(() => {
          this.paperQuestions = []
          window.alert('加载当前试卷题目失败，请检查后端服务')
        })
    },
    loadQuestionDetailsForPaper() {
      const ids = Array.from(new Set((this.paperQuestions || []).map((x) => Number(x.questionId)).filter((x) => Number.isFinite(x) && x > 0)))
      if (!ids.length) {
        this.questionDetailMap = {}
        return
      }
      const concurrency = 6
      const map = {}
      let cursor = 0
      const runNext = () => {
        if (cursor >= ids.length) {
          return Promise.resolve()
        }
        const id = ids[cursor++]
        return fetch(`/api/crud/question/${id}`, { headers: this.authHeaders() })
          .then((r) => r.json())
          .then((res) => {
            if (res && res.data) map[id] = res.data
          })
          .catch(() => {})
          .then(() => runNext())
      }
      const workers = []
      for (let i = 0; i < Math.min(concurrency, ids.length); i += 1) {
        workers.push(runNext())
      }
      Promise.all(workers).then(() => {
        this.questionDetailMap = { ...map }
      })
    },
    questionTypeText(type) {
      const t = String(type || '').toLowerCase()
      if (t === 'radio') return '单选'
      if (t === 'multiple') return '多选'
      if (t === 'judge') return '判断'
      if (t === 'fill') return '填空'
      if (t === 'essay') return '简答'
      if (t === 'coding') return '编程题'
      if (t === 'material_collect') return '资料收集'
      if (t === 'scratch') return 'Scratch编程'
      return type || '-'
    },
    questionDifficultyText(difficulty) {
      const d = String(difficulty || '').toLowerCase()
      if (d === 'easy') return '简单'
      if (d === 'middle') return '中等'
      if (d === 'hard') return '困难'
      return difficulty || '-'
    },
    getCurrentPaperTotalScore() {
      const paper = this.papers.find((p) => String(p.id) === String(this.selectedPaperId))
      if (paper && Number.isFinite(Number(paper.totalScore))) {
        return Number(paper.totalScore)
      }
      if (Number.isFinite(Number(this.form.totalScore))) {
        return Number(this.form.totalScore)
      }
      return 0
    },
    calcQuestionTotal(rows) {
      return (rows || []).reduce((sum, row) => sum + Number(row.score || 0), 0)
    },
    validatePaperScoresCommit() {
      if (!this.selectedPaperId) {
        window.alert('请先选择试卷')
        return
      }
      fetch(`/api/teacher/paper-compose/${this.selectedPaperId}/validate-scores`, {
        method: 'POST',
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            window.alert(res.data || res.message || '题目分值合计与试卷总分一致')
            return
          }
          window.alert(res.message || '校验未通过')
        })
        .catch(() => window.alert('校验请求失败，请检查后端服务'))
    },
    recalcAndSyncPaperTotal() {
      if (!this.selectedPaperId) {
        window.alert('请先选择试卷')
        return
      }
      const paper = this.papers.find((p) => String(p.id) === String(this.selectedPaperId))
      if (!paper) {
        window.alert('未找到当前试卷信息')
        return
      }
      const sumScore = this.calcQuestionTotal(this.paperQuestions)
      fetch(`/api/crud/exam-paper/${this.selectedPaperId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: paper.id,
          paperName: paper.paperName,
          totalScore: sumScore,
          examDuration: Number(paper.examDuration || 0),
          passScore: Number(paper.passScore || 0),
          createType: paper.createType || 'manual'
        })
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code !== 200 && typeof res.code !== 'undefined') {
            window.alert(res.message || '同步试卷总分失败')
            return
          }
          this.form.totalScore = sumScore
          this.loadPapers()
          window.alert(`同步成功：试卷总分已更新为 ${sumScore} 分`)
        })
        .catch(() => window.alert('同步试卷总分失败，请检查后端服务'))
    },
    updatePaperQuestion(pq) {
      if (!pq || !pq.id) return
      const score = Number(pq.score)
      const sort = Number(pq.sort)
      if (!Number.isFinite(score) || score < 0 || !Number.isFinite(sort) || sort < 0) {
        window.alert('分值和排序必须是大于等于0的数字')
        return
      }
      fetch(`/api/crud/paper-question/${pq.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: pq.id,
          paperId: pq.paperId,
          questionId: pq.questionId,
          score,
          sort
        })
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code !== 200 && typeof res.code !== 'undefined') {
            window.alert(res.message || '修改题目失败')
            return
          }
          this.loadPaperQuestions(true)
          window.alert(`修改成功：题目ID ${pq.questionId} 分值=${score}，排序=${sort}`)
        })
        .catch(() => window.alert('修改题目失败，请检查后端服务'))
    },
    async deletePaperQuestion(pq) {
      if (!pq || !pq.id) return
      if (!(await appConfirm(`确认删除题目ID ${pq.questionId} 吗？`))) return
      fetch(`/api/crud/paper-question/${pq.id}`, {
        method: 'DELETE'
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code !== 200 && typeof res.code !== 'undefined') {
            window.alert(res.message || '删除题目失败')
            return
          }
          this.loadPaperQuestions(true)
        })
        .catch(() => window.alert('删除题目失败，请检查后端服务'))
    },
    openPaperQuestionEditModal(pq) {
      if (!pq || pq.questionId == null || pq.questionId === '') return
      const id = Number(pq.questionId)
      if (!Number.isFinite(id) || id <= 0) {
        window.alert('无效的题目 ID')
        return
      }
      this.editingPaperQuestionId = id
      const detailReq = fetch(`/api/crud/question/${id}`, { headers: this.authHeaders() }).then((r) => r.json())
      const listReq = fetch('/api/teacher/question/questions?page=0&size=2000', {
        headers: this.authHeaders()
      }).then((r) => r.json())
      Promise.all([detailReq, listReq])
        .then(([detailRes, listRes]) => {
          if (!detailRes || detailRes.code !== 200 || !detailRes.data) {
            window.alert((detailRes && detailRes.message) || '加载题目详情失败')
            return
          }
          const q = detailRes.data
          const items = (listRes && listRes.data && listRes.data.content) || []
          const matched = items.find((x) => Number(x.question && x.question.id) === id) || null
          const selectedTagIds = this.tags
            .filter((t) => (matched && matched.tags ? matched.tags : []).includes(t.tagName))
            .map((t) => t.id)
          const stemList = parseUrlList(q.contentImages)
          const anaList = parseUrlList(q.analysisImages)
          this.editingPaperQuestion = {
            bankId: q.bankId != null ? q.bankId : null,
            type: q.type || 'radio',
            title: q.title || '',
            options: q.options || '',
            answer: q.answer || '',
            analysis: q.analysis || '',
            difficulty: q.difficulty || 'middle',
            score: Number(q.score || 0),
            tagIds: selectedTagIds,
            contentImages: stemList.slice(),
            analysisImages: anaList.slice(),
            optionAImage: q.optionAImage ? String(q.optionAImage) : '',
            optionBImage: q.optionBImage ? String(q.optionBImage) : '',
            optionCImage: q.optionCImage ? String(q.optionCImage) : '',
            optionDImage: q.optionDImage ? String(q.optionDImage) : ''
          }
          this.editingChoiceOptions = this.parseChoiceOptions(this.editingPaperQuestion.options)
          this.showPaperQuestionEditModal = true
        })
        .catch(() => window.alert('加载题目详情失败，请检查后端服务'))
    },
    buildTeacherPaperQuestionPayload() {
      const e = this.editingPaperQuestion
      const stem = Array.isArray(e.contentImages) ? e.contentImages.map((x) => String(x || '').trim()).filter(Boolean) : []
      const ana = Array.isArray(e.analysisImages) ? e.analysisImages.map((x) => String(x || '').trim()).filter(Boolean) : []
      const payload = {
        bankId: e.bankId != null ? e.bankId : null,
        type: e.type,
        title: e.title,
        answer: e.answer,
        analysis: e.analysis,
        difficulty: e.difficulty,
        score: Number(e.score || 0),
        tagIds: Array.isArray(e.tagIds) ? e.tagIds : [],
        contentImages: stem,
        analysisImages: ana,
        optionAImage: e.optionAImage ? String(e.optionAImage).trim() : '',
        optionBImage: e.optionBImage ? String(e.optionBImage).trim() : '',
        optionCImage: e.optionCImage ? String(e.optionCImage).trim() : '',
        optionDImage: e.optionDImage ? String(e.optionDImage).trim() : ''
      }
      if (this.isChoiceType(e.type)) {
        payload.options = this.buildChoiceOptions()
      } else {
        payload.options = e.options || ''
      }
      return payload
    },
    paperEditOptionImg(key) {
      const k = String(key || '').toUpperCase()
      const e = this.editingPaperQuestion
      if (!e) return ''
      if (k === 'A') return e.optionAImage || ''
      if (k === 'B') return e.optionBImage || ''
      if (k === 'C') return e.optionCImage || ''
      if (k === 'D') return e.optionDImage || ''
      return ''
    },
    paperEditClearOptionImg(key) {
      const k = String(key || '').toUpperCase()
      if (k === 'A') this.editingPaperQuestion.optionAImage = ''
      else if (k === 'B') this.editingPaperQuestion.optionBImage = ''
      else if (k === 'C') this.editingPaperQuestion.optionCImage = ''
      else if (k === 'D') this.editingPaperQuestion.optionDImage = ''
    },
    async teacherPostPaperImage(file) {
      if (!file) return null
      if (file.size > 5 * 1024 * 1024) {
        window.alert('单张图片不能超过 5MB')
        return null
      }
      const fd = new FormData()
      fd.append('file', file)
      const r = await fetch('/api/teacher/question/questions/images/upload', {
        method: 'POST',
        headers: this.authHeaders(),
        body: fd
      })
      const j = await r.json()
      if (j.code !== 200 || !j.data || !j.data.url) {
        window.alert(j.message || '上传失败')
        return null
      }
      return j.data.url
    },
    async onPaperEditStemUpload(ev) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostPaperImage(f)
      if (!url) return
      if (!Array.isArray(this.editingPaperQuestion.contentImages)) this.editingPaperQuestion.contentImages = []
      this.editingPaperQuestion.contentImages.push(url)
    },
    async onPaperEditStemReplace(ev, idx) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostPaperImage(f)
      if (!url || !Array.isArray(this.editingPaperQuestion.contentImages)) return
      this.editingPaperQuestion.contentImages.splice(Number(idx), 1, url)
    },
    async onPaperEditAnalysisUpload(ev) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostPaperImage(f)
      if (!url) return
      if (!Array.isArray(this.editingPaperQuestion.analysisImages)) this.editingPaperQuestion.analysisImages = []
      this.editingPaperQuestion.analysisImages.push(url)
    },
    async onPaperEditAnalysisReplace(ev, idx) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostPaperImage(f)
      if (!url || !Array.isArray(this.editingPaperQuestion.analysisImages)) return
      this.editingPaperQuestion.analysisImages.splice(Number(idx), 1, url)
    },
    async onPaperEditOptImg(ev, key) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostPaperImage(f)
      if (!url) return
      const k = String(key || '').toUpperCase()
      if (k === 'A') this.editingPaperQuestion.optionAImage = url
      else if (k === 'B') this.editingPaperQuestion.optionBImage = url
      else if (k === 'C') this.editingPaperQuestion.optionCImage = url
      else if (k === 'D') this.editingPaperQuestion.optionDImage = url
    },
    parseChoiceOptions(raw) {
      const empty = { A: '', B: '', C: '', D: '' }
      if (!raw) return empty
      try {
        const obj = JSON.parse(raw)
        if (Array.isArray(obj)) {
          return {
            A: String(obj[0] || ''),
            B: String(obj[1] || ''),
            C: String(obj[2] || ''),
            D: String(obj[3] || '')
          }
        }
        if (obj && typeof obj === 'object') {
          return {
            A: String(obj.A || obj.a || ''),
            B: String(obj.B || obj.b || ''),
            C: String(obj.C || obj.c || ''),
            D: String(obj.D || obj.d || '')
          }
        }
      } catch (e) {
        const lines = String(raw).split('\n')
        return {
          A: String(lines[0] || ''),
          B: String(lines[1] || ''),
          C: String(lines[2] || ''),
          D: String(lines[3] || '')
        }
      }
      return empty
    },
    buildChoiceOptions() {
      return JSON.stringify({
        A: String(this.editingChoiceOptions.A || ''),
        B: String(this.editingChoiceOptions.B || ''),
        C: String(this.editingChoiceOptions.C || ''),
        D: String(this.editingChoiceOptions.D || '')
      })
    },
    isChoiceType(type) {
      const t = String(type || '').toLowerCase()
      return t === 'radio' || t === 'multiple'
    },
    onPaperQuestionTypeChange() {
      if (this.isChoiceType(this.editingPaperQuestion.type)) {
        this.editingChoiceOptions = this.parseChoiceOptions(this.editingPaperQuestion.options)
      }
    },
    closePaperQuestionEditModal() {
      this.showPaperQuestionEditModal = false
      this.paperEditImgLightbox = null
    },
    savePaperQuestionEditModal() {
      if (!this.editingPaperQuestionId) return
      const payload = this.buildTeacherPaperQuestionPayload()
      fetch(`/api/teacher/question/questions/${this.editingPaperQuestionId}`, {
        method: 'PUT',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(payload)
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code !== 200) {
            window.alert(res.message || '保存题目修改失败')
            return
          }
          return this.syncCurrentPaperQuestionScore(Number(this.editingPaperQuestionId), Number(payload.score || 0)).then(() => {
            this.showPaperQuestionEditModal = false
            this.paperEditImgLightbox = null
            this.loadCandidateQuestions()
            this.loadPaperQuestions(true)
            this.loadPapers()
            window.alert('题目信息已更新，已自动刷新题库与当前试卷数据')
          })
        })
        .catch(() => window.alert('保存题目修改失败，请检查后端服务'))
    },
    syncCurrentPaperQuestionScore(questionId, nextScore) {
      if (!this.selectedPaperId || !Number.isFinite(questionId)) {
        return Promise.resolve()
      }
      const rows = (this.paperQuestions || []).filter((x) => Number(x.questionId) === Number(questionId))
      if (rows.length === 0) {
        return Promise.resolve()
      }
      const safeScore = Number.isFinite(nextScore) && nextScore >= 0 ? Number(nextScore) : 0
      const reqs = rows.map((pq) =>
        fetch(`/api/crud/paper-question/${pq.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: pq.id,
            paperId: pq.paperId,
            questionId: pq.questionId,
            score: safeScore,
            sort: pq.sort
          })
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.code !== 200 && typeof res.code !== 'undefined') {
              throw new Error(res.message || '同步当前试卷题目分值失败')
            }
          })
      )
      return Promise.all(reqs).then(() => undefined)
    },
    toggleCheckAllCurrentPage(e) {
      const checked = !!(e && e.target && e.target.checked)
      const currentIds = this.pagedPaperQuestions.map((x) => x.id)
      const set = new Set(this.selectedPaperQuestionIds)
      if (checked) {
        currentIds.forEach((id) => set.add(id))
      } else {
        currentIds.forEach((id) => set.delete(id))
      }
      this.selectedPaperQuestionIds = Array.from(set)
    },
    async batchDeletePaperQuestions() {
      if (!this.selectedPaperQuestionIds || this.selectedPaperQuestionIds.length === 0) {
        window.alert('请先勾选要删除的题目')
        return
      }
      if (!(await appConfirm(`确认批量删除已勾选的 ${this.selectedPaperQuestionIds.length} 道题吗？`))) {
        return
      }
      const reqs = this.selectedPaperQuestionIds.map((id) =>
        fetch(`/api/crud/paper-question/${id}`, { method: 'DELETE' })
          .then((r) => r.json())
          .then((res) => {
            if (res.code !== 200 && typeof res.code !== 'undefined') {
              throw new Error(res.message || '批量删除失败')
            }
          })
      )
      Promise.all(reqs)
        .then(() => {
          window.alert('批量删除成功')
          this.loadPaperQuestions(true)
        })
        .catch((err) => window.alert((err && err.message) || '批量删除失败'))
    },
    onPaperQuestionDragStart(index) {
      this.dragPaperQuestionIndex = Number(index)
    },
    onPaperQuestionDrop(targetIndex) {
      const from = Number(this.dragPaperQuestionIndex)
      const to = Number(targetIndex)
      if (!Number.isFinite(from) || !Number.isFinite(to) || from < 0 || to < 0 || from === to) {
        this.dragPaperQuestionIndex = null
        return
      }
      const rows = this.paperQuestions.slice()
      const moving = rows.splice(from, 1)[0]
      if (!moving) {
        this.dragPaperQuestionIndex = null
        return
      }
      rows.splice(to, 0, moving)
      this.paperQuestions = rows.map((row, idx) => ({
        ...row,
        sort: idx
      }))
      this.dragPaperQuestionIndex = null
    },
    savePaperQuestionOrder() {
      if (!this.paperQuestions || this.paperQuestions.length === 0) {
        window.alert('当前没有可排序题目')
        return
      }
      const requests = this.paperQuestions.map((pq, idx) =>
        fetch(`/api/crud/paper-question/${pq.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: pq.id,
            paperId: pq.paperId,
            questionId: pq.questionId,
            score: Number(pq.score || 0),
            sort: idx
          })
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.code !== 200 && typeof res.code !== 'undefined') {
              throw new Error(res.message || '保存排序失败')
            }
          })
      )
      Promise.all(requests)
        .then(() => {
          this.loadPaperQuestions(true)
          window.alert('排序保存成功')
        })
        .catch((err) => window.alert((err && err.message) || '排序保存失败'))
    },
    fillFormByPaper(paperId) {
      this.selectedPaperId = paperId
      const paper = this.papers.find((p) => String(p.id) === String(paperId))
      if (!paper) return
      this.selectedExamId = null
      this.selectedExamConfigId = null
      this.form.paperName = paper.paperName || ''
      this.form.totalScore = paper.totalScore || 0
      this.form.examDuration = paper.examDuration || 0
      this.form.passScore = paper.passScore || 0
    },
    openPaperEditModal(paperId) {
      const paper = this.papers.find((p) => String(p.id) === String(paperId))
      if (!paper) return
      this.paperEditForm = {
        id: paper.id,
        paperName: paper.paperName || '',
        totalScore: Number(paper.totalScore || 0),
        examDuration: Number(paper.examDuration || 0),
        passScore: Number(paper.passScore || 0)
      }
      this.showPaperEditModal = true
    },
    closePaperEditModal() {
      this.showPaperEditModal = false
    },
    savePaperEdit() {
      if (!this.paperEditForm.id) return
      if (!this.paperEditForm.paperName || !String(this.paperEditForm.paperName).trim()) {
        window.alert('请填写试卷名称')
        return
      }
      const paperId = this.paperEditForm.id
      fetch(`/api/crud/exam-paper/${paperId}`, {
        method: 'PUT',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({
          id: paperId,
          paperName: this.paperEditForm.paperName,
          totalScore: this.paperEditForm.totalScore,
          examDuration: this.paperEditForm.examDuration,
          passScore: this.paperEditForm.passScore,
          createType: 'manual'
        })
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code !== 200 && res.code !== undefined) {
            throw new Error(res.message || '保存试卷失败')
          }
          this.showPaperEditModal = false
          this.loadPapers()
          window.alert('保存成功')
        })
        .catch((e) => {
          window.alert((e && e.message) || '保存失败')
        })
    },
    toLocalInput(value) {
      if (!value) return ''
      return String(value).replace('T', ' ').slice(0, 16).replace(' ', 'T')
    },
    fromLocalInput(value) {
      if (!value) return null
      // CRUD(Jackson) 需要 ISO：yyyy-MM-ddTHH:mm:ss；datetime-local 通常为 yyyy-MM-ddTHH:mm
      let v = String(value).trim().replace(' ', 'T')
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(v)) {
        return `${v}:00`
      }
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(v)) {
        return v.slice(0, 19)
      }
      return v
    },
    clearForm() {
      this.selectedPaperId = null
      this.selectedExamId = null
      this.selectedExamConfigId = null
      this.form = this.makeEmptyForm()
      this.selectedQuestionIds = []
      this.candidateQuestions = []
      this.paperQuestions = []
    },
    parseParticipantIds() {
      if (!this.examForm.participantUserIdsText) return []
      return this.examForm.participantUserIdsText
        .split(',')
        .map((x) => Number(String(x).trim()))
        .filter((x) => Number.isFinite(x) && x > 0)
    },
    parseIdsFromText(text) {
      if (!text) return []
      const uniq = new Set()
      String(text)
        .split(',')
        .map((x) => Number(String(x).trim()))
        .filter((x) => Number.isFinite(x) && x > 0)
        .forEach((id) => uniq.add(id))
      return Array.from(uniq)
    },
    statusText(status) {
      const s = String(status || '').toUpperCase()
      if (s === 'NOT_START') return '未开始'
      if (s === 'ING') return '进行中'
      if (s === 'END') return '已结束'
      return status || '-'
    },
    statusClass(status) {
      const s = String(status || '').toUpperCase()
      if (s === 'ING') return 'status-ing'
      if (s === 'END') return 'status-end'
      return 'status-not-start'
    },
    gradingStatusText(status) {
      const s = String(status || '').toUpperCase()
      if (s === 'ASSIGNED') return '已分配'
      if (s === 'COMMIT') return '已提交'
      if (s === 'FORCE_END') return '强制交卷'
      if (s === 'GRADED') return '已阅卷'
      return status || '-'
    },
    goGradingWorkspace(recordRow) {
      if (!recordRow || !recordRow.recordId) {
        window.alert('该学员暂无可阅卷记录')
        return
      }
      const params = new URLSearchParams({
        recordId: String(recordRow.recordId || ''),
        userId: String(recordRow.userId || ''),
        username: String(recordRow.username || ''),
        status: String(recordRow.status || ''),
        score: String(recordRow.score || 0),
        submitTime: String(recordRow.submitTime || ''),
        examId: String(this.gradingExamId || this.participantManageExam.id || '')
      })
      window.location.hash = `#/teacher/grading?${params.toString()}`
    },
    saveExam() {
      if (!this.examForm.examName || !this.examForm.paperId || !this.examForm.startTime || !this.examForm.endTime) {
        window.alert('请完整填写考试名称、试卷、开始时间、结束时间')
        return
      }
      const body = {
        examName: this.examForm.examName,
        paperId: this.examForm.paperId,
        startTime: this.fromLocalInput(this.examForm.startTime) || this.examForm.startTime,
        endTime: this.fromLocalInput(this.examForm.endTime) || this.examForm.endTime,
        showAnalysis: Number(this.examForm.showAnalysis) === 0 ? 0 : 1,
        showAnswerAfterSubmit: Number(this.examForm.showAnswerAfterSubmit) === 1 ? 1 : 0,
        allowRedo: Number(this.examForm.allowRedo) === 1 ? 1 : 0,
        participantUserIds: this.parseParticipantIds()
      }
      const isUpdate = !!this.selectedExamManageId
      const url = isUpdate
        ? `/api/teacher/exam-manage/update/${this.selectedExamManageId}`
        : '/api/teacher/exam-manage/create'
      const method = isUpdate ? 'PUT' : 'POST'
      fetch(url, {
        method,
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(body)
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            this.loadExamList()
            this.loadExamsAndConfigs()
            this.resetExamForm()
          } else {
            window.alert(res.message || '保存考试失败')
          }
        })
    },
    fillExamForm(item) {
      this.selectedExamManageId = item.exam.id
      this.examForm.examName = item.exam.examName || ''
      this.examForm.paperId = item.exam.paperId || null
      this.examForm.startTime = this.toLocalInput(item.exam.startTime)
      this.examForm.endTime = this.toLocalInput(item.exam.endTime)
      this.examForm.showAnalysis = typeof item.showAnalysis !== 'undefined' && item.showAnalysis !== null
        ? Number(item.showAnalysis)
        : 1
      this.examForm.showAnswerAfterSubmit = typeof item.showAnswerAfterSubmit !== 'undefined' && item.showAnswerAfterSubmit !== null
        ? Number(item.showAnswerAfterSubmit)
        : 0
      this.examForm.allowRedo = typeof item.allowRedo !== 'undefined' && item.allowRedo !== null
        ? Number(item.allowRedo)
        : 0
      this.examForm.participantUserIdsText = (item.participantUserIds || []).join(',')
    },
    openExamEditModal(item) {
      this.examEditForm = {
        id: item.exam.id,
        examName: item.exam.examName || '',
        paperId: item.exam.paperId || null,
        startTime: this.toLocalInput(item.exam.startTime),
        endTime: this.toLocalInput(item.exam.endTime),
        status: item.exam.status || 'NOT_START',
        showAnalysis: typeof item.showAnalysis !== 'undefined' && item.showAnalysis !== null
          ? Number(item.showAnalysis)
          : 1,
        showAnswerAfterSubmit: typeof item.showAnswerAfterSubmit !== 'undefined' && item.showAnswerAfterSubmit !== null
          ? Number(item.showAnswerAfterSubmit)
          : 0,
        allowRedo: typeof item.allowRedo !== 'undefined' && item.allowRedo !== null
          ? Number(item.allowRedo)
          : 0,
        participantUserIdsText: (item.participantUserIds || []).join(',')
      }
      this.showExamEditModal = true
    },
    closeExamEditModal() {
      this.showExamEditModal = false
    },
    saveExamEdit() {
      if (!this.examEditForm.id) return
      const payload = {
        examName: this.examEditForm.examName,
        paperId: this.examEditForm.paperId,
        startTime: this.fromLocalInput(this.examEditForm.startTime) || this.examEditForm.startTime,
        endTime: this.fromLocalInput(this.examEditForm.endTime) || this.examEditForm.endTime,
        showAnalysis: Number(this.examEditForm.showAnalysis) === 0 ? 0 : 1,
        showAnswerAfterSubmit: Number(this.examEditForm.showAnswerAfterSubmit) === 1 ? 1 : 0,
        allowRedo: Number(this.examEditForm.allowRedo) === 1 ? 1 : 0,
        participantUserIds: (this.examEditForm.participantUserIdsText || '')
          .split(',')
          .map((x) => Number(String(x).trim()))
          .filter((x) => Number.isFinite(x) && x > 0)
      }
      fetch(`/api/teacher/exam-manage/update/${this.examEditForm.id}`, {
        method: 'PUT',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(payload)
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            this.showExamEditModal = false
            this.loadExamList()
            this.loadExamsAndConfigs()
            return
          }
          window.alert(res.message || '保存考试失败')
        })
    },
    openParticipantManageModal(item) {
      this.participantManageExam = {
        id: item.exam.id,
        examName: item.exam.examName || '',
        paperId: item.exam.paperId || null,
        startTime: this.toLocalInput(item.exam.startTime),
        endTime: this.toLocalInput(item.exam.endTime)
      }
      this.participantRecords = (item.participantUserIds || []).map((uid, idx) => ({
        userId: uid,
        username: (item.participantUsernames && item.participantUsernames[idx]) || '',
        status: 'ASSIGNED',
        score: 0,
        submitTime: ''
      }))
      this.selectedParticipantIds = []
      this.participantDraftText = ''
      this.participantTicketDraftText = ''
      this.participantManageTicketExcelFile = null
      this.participantAutomanDraftText = ''
      this.participantManageAutomanExcelFile = null
      this.userSearchKeyword = ''
      this.userSearchUsername = ''
      this.userSearchRealName = ''
      this.userSearchIdFrom = ''
      this.userSearchIdTo = ''
      this.userSearchRows = []
      this.userSearchPage = 0
      this.userSearchTotalElements = 0
      this.userSearchTotalPages = 1
      this.userSearchTicketExtra = 0
      this.selectedSearchUserIds = []
      this.showParticipantManageModal = true
      this.loadParticipantRecords(item.exam.id)
      this.searchStudentUsers(0)
    },
    closeParticipantManageModal() {
      this.showParticipantManageModal = false
      this.participantManageExcelFile = null
      this.participantManageTicketExcelFile = null
      this.participantTicketDraftText = ''
      this.participantManageAutomanExcelFile = null
      this.participantAutomanDraftText = ''
      this.selectedParticipantIds = []
      this.userSearchRows = []
      this.selectedSearchUserIds = []
      this.userSearchKeyword = ''
      this.userSearchUsername = ''
      this.userSearchRealName = ''
      this.userSearchIdFrom = ''
      this.userSearchIdTo = ''
      this.userSearchPage = 0
      this.userSearchTotalElements = 0
      this.userSearchTotalPages = 1
      this.userSearchTicketExtra = 0
    },
    loadParticipantRecords(examId) {
      if (!examId) return
      fetch(`/api/teacher/exam-manage/participants/${examId}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json().then((res) => ({ ok: r.ok, status: r.status, res })))
        .then(({ ok, status, res }) => {
          if (ok && res.code === 200) {
            this.participantRecords = res.data || []
            if (this.showParticipantManageModal && this.hideAddedUsersInSearch) {
              this.searchStudentUsers(this.userSearchPage || 0)
            }
            return
          }
          // 兼容旧后端（尚未部署导入人接口）
          if (status === 404) {
            return fetch(`/api/student/exam/answers/exam/${examId}`, {
              headers: this.authHeaders()
            })
              .then((r) => r.json())
              .then((legacy) => {
                if (legacy.code === 200) {
                  this.participantRecords = legacy.data || []
                  return
                }
                window.alert(legacy.message || res.message || '加载参考人员失败')
              })
          }
          window.alert((res && res.message) || '加载参考人员失败')
        })
        .catch(() => window.alert('加载参考人员失败，请检查网络后重试'))
    },
    exportParticipants() {
      this.exportParticipantsForExam(this.participantManageExam.id, this.participantManageExam.examName)
    },
    exportParticipantsForExam(examId, examName) {
      if (!examId) {
        window.alert('请先选择考试')
        return
      }
      fetch(`/api/teacher/exam-manage/participants/${examId}/export`, {
        headers: this.authHeaders()
      })
        .then(async (r) => {
          if (!r.ok) {
            let msg = '导出失败'
            try {
              const j = await r.json()
              if (j && j.message) msg = j.message
            } catch (e) {
              /* ignore */
            }
            if (r.status === 404) {
              msg = '导出接口尚未部署到云端，请先发布后端后再试'
            }
            throw new Error(msg)
          }
          return r.blob()
        })
        .then((blob) => {
          const a = document.createElement('a')
          const url = URL.createObjectURL(blob)
          a.href = url
          const safe = String(examName || 'exam').replace(/[\\/:*?"<>|]/g, '_')
          a.download = `exam_${examId}_participants_${safe}.xlsx`
          document.body.appendChild(a)
          a.click()
          a.remove()
          URL.revokeObjectURL(url)
        })
        .catch((e) => window.alert((e && e.message) || '导出学生名单失败'))
    },
    openPaperParticipantsModal(paper) {
      if (!paper || !paper.id) return
      this.paperParticipantsMeta = {
        paperId: paper.id,
        paperName: paper.paperName || '',
        examCount: 0,
        participantCount: 0,
        uniqueStudentCount: 0
      }
      this.paperParticipantRows = []
      this.showPaperParticipantsModal = true
      this.loadPaperParticipants(paper.id)
    },
    closePaperParticipantsModal() {
      this.showPaperParticipantsModal = false
      this.paperParticipantsLoading = false
      this.paperParticipantRows = []
    },
    loadPaperParticipants(paperId) {
      if (!paperId) return
      this.paperParticipantsLoading = true
      fetch(`/api/teacher/exam-manage/paper/${paperId}/participants`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code !== 200) {
            window.alert(res.message || '加载试卷学生失败')
            this.paperParticipantRows = []
            return
          }
          const data = res.data || {}
          this.paperParticipantsMeta = {
            paperId: data.paperId || paperId,
            paperName: data.paperName || this.paperParticipantsMeta.paperName || '',
            examCount: Number(data.examCount || 0),
            participantCount: Number(data.participantCount || 0),
            uniqueStudentCount: Number(data.uniqueStudentCount || 0)
          }
          this.paperParticipantRows = Array.isArray(data.rows) ? data.rows : []
        })
        .catch(() => window.alert('加载试卷学生失败，请检查网络后重试'))
        .finally(() => {
          this.paperParticipantsLoading = false
        })
    },
    exportPaperParticipants(paperId, paperName) {
      if (!paperId) {
        window.alert('请先选择试卷')
        return
      }
      fetch(`/api/teacher/exam-manage/paper/${paperId}/participants/export`, {
        headers: this.authHeaders()
      })
        .then(async (r) => {
          if (!r.ok) {
            let msg = '导出失败'
            try {
              const j = await r.json()
              if (j && j.message) msg = j.message
            } catch (e) {
              /* ignore */
            }
            throw new Error(msg)
          }
          return r.blob()
        })
        .then((blob) => {
          const a = document.createElement('a')
          const url = URL.createObjectURL(blob)
          a.href = url
          const safe = String(paperName || 'paper').replace(/[\\/:*?"<>|]/g, '_')
          a.download = `paper_${paperId}_participants_${safe}.xlsx`
          document.body.appendChild(a)
          a.click()
          a.remove()
          URL.revokeObjectURL(url)
        })
        .catch((e) => window.alert((e && e.message) || '导出试卷学生失败'))
    },
    buildImporterSummary(rows) {
      const map = new Map()
      ;(rows || []).forEach((r) => {
        let name = String((r && r.assignedByName) || '').trim()
        if (!name && r && r.assignedBy) name = `ID:${r.assignedBy}`
        if (!name) name = '(未记录导入人)'
        map.set(name, (map.get(name) || 0) + 1)
      })
      return Array.from(map.entries())
        .map(([name, count]) => ({ name, count }))
        .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name, 'zh-CN'))
    },
    appendParticipantsByText() {
      const appendIds = this.parseIdsFromText(this.participantDraftText)
      if (appendIds.length === 0) {
        window.alert('请输入正确的用户ID')
        return
      }
      const map = new Map(this.participantRecords.map((x) => [Number(x.userId), x]))
      appendIds.forEach((id) => {
        if (!map.has(id)) {
          map.set(id, { userId: id, username: '', status: 'ASSIGNED', score: 0, submitTime: '' })
        }
      })
      this.participantRecords = Array.from(map.values())
      this.participantDraftText = ''
    },
    searchStudentUsers(page) {
      const pageNo = Number.isFinite(Number(page)) ? Math.max(0, Number(page)) : 0
      this.userSearchLoading = true
      this.userSearchPage = pageNo
      const params = new URLSearchParams({
        page: String(pageNo),
        size: String(this.userSearchPageSize || 20)
      })
      if (this.userSearchKeyword && this.userSearchKeyword.trim()) {
        params.append('keyword', this.userSearchKeyword.trim())
      }
      if (this.userSearchUsername && this.userSearchUsername.trim()) {
        params.append('username', this.userSearchUsername.trim())
      }
      if (this.userSearchRealName && this.userSearchRealName.trim()) {
        params.append('realName', this.userSearchRealName.trim())
      }
      const idFrom = Number(this.userSearchIdFrom)
      const idTo = Number(this.userSearchIdTo)
      if (Number.isFinite(idFrom) && idFrom > 0) params.append('idFrom', String(idFrom))
      if (Number.isFinite(idTo) && idTo > 0) params.append('idTo', String(idTo))
      if (this.hideAddedUsersInSearch) {
        const excludeIds = this.participantRecords
          .map((x) => Number(x.userId))
          .filter((id) => Number.isFinite(id) && id > 0)
        if (excludeIds.length) {
          params.append('excludeUserIds', excludeIds.join(','))
        }
      }
      fetch(`/api/teacher/exam-manage/search-assignable-students?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            const data = res.data || {}
            // 兼容旧版数组返回
            if (Array.isArray(data)) {
              this.userSearchRows = data
              this.userSearchTotalElements = data.length
              this.userSearchTotalPages = 1
              this.userSearchPage = 0
              this.userSearchTicketExtra = 0
            } else {
              this.userSearchRows = Array.isArray(data.content) ? data.content : []
              this.userSearchTotalElements = Number(data.totalElements || 0)
              this.userSearchTotalPages = Math.max(1, Number(data.totalPages || 1))
              this.userSearchPage = Number(data.number || pageNo)
              this.userSearchTicketExtra = Number(data.ticketExtra || 0)
            }
            this.selectedSearchUserIds = []
            return
          }
          window.alert(res.message || '查询学员失败')
        })
        .catch(() => window.alert('网络异常，查询学员失败'))
        .finally(() => {
          this.userSearchLoading = false
        })
    },
    toggleAllSearchUsers(event) {
      const checked = !!(event && event.target && event.target.checked)
      this.selectedSearchUserIds = checked
        ? this.filteredUserSearchRows.map((x) => x.selectionKey || (x.id != null ? `u:${x.id}` : `t:${x.ticketNo}`))
        : []
    },
    async appendSelectedSearchUsers() {
      if (!this.selectedSearchUserIds.length) {
        window.alert('请先勾选学员')
        return
      }
      const rowMap = new Map(
        this.userSearchRows.map((x) => [x.selectionKey || (x.id != null ? `u:${x.id}` : `t:${x.ticketNo}`), x])
      )
      const map = new Map(this.participantRecords.map((x) => [Number(x.userId), x]))
      const ticketsToEnsure = []
      this.selectedSearchUserIds.forEach((key) => {
        const u = rowMap.get(key) || {}
        if (u.unbound || u.fromTicketInventory || !u.id) {
          const tn = String(u.ticketNo || '').trim()
          if (tn) ticketsToEnsure.push(tn)
          return
        }
        const id = Number(u.id)
        if (!Number.isFinite(id) || id <= 0) return
        if (!map.has(id)) {
          map.set(id, {
            userId: id,
            username: u.username || '',
            ticketNo: u.ticketNo || '',
            status: 'ASSIGNED',
            score: 0,
            submitTime: ''
          })
        }
      })
      if (ticketsToEnsure.length) {
        try {
          const r = await fetch('/api/teacher/exam-manage/resolve-participants-by-ticket', {
            method: 'POST',
            headers: this.authHeaders({ 'Content-Type': 'application/json' }),
            body: JSON.stringify({ ticketsText: ticketsToEnsure.join(',') })
          })
          const res = await r.json()
          if (res.code !== 200 || !res.data) {
            window.alert(res.message || '准考证建号失败')
            return
          }
          const ids = res.data.userIds || []
          const names = res.data.usernames || []
          const tnos = res.data.ticketNos || []
          ids.forEach((uid, idx) => {
            const id = Number(uid)
            if (!Number.isFinite(id) || id <= 0) return
            if (!map.has(id)) {
              map.set(id, {
                userId: id,
                username: names[idx] || '',
                ticketNo: tnos[idx] || '',
                status: 'ASSIGNED',
                score: 0,
                submitTime: ''
              })
            }
          })
          const errList = Array.isArray(res.data.errors) ? res.data.errors : []
          if (errList.length) {
            window.alert(`部分准考证建号失败：\n${errList.slice(0, 5).join('\n')}`)
          }
        } catch (e) {
          window.alert('网络异常，准考证建号失败')
          return
        }
      }
      this.participantRecords = Array.from(map.values())
      this.selectedSearchUserIds = []
    },
    onManageParticipantExcelChange(e) {
      this.participantManageExcelFile = (e.target.files && e.target.files[0]) || null
    },
    importParticipantsForManage() {
      if (!this.participantManageExcelFile) {
        window.alert('请先选择Excel文件')
        return
      }
      const form = new FormData()
      form.append('file', this.participantManageExcelFile)
      fetch('/api/teacher/exam-manage/import-participants', {
        method: 'POST',
        headers: this.authHeaders(),
        body: form
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200 && res.data) {
            const allText = [this.participantDraftText, (res.data.userIds || []).join(',')].filter(Boolean).join(',')
            this.participantDraftText = allText
            this.appendParticipantsByText()
            return
          }
          window.alert(res.message || '导入失败')
        })
    },
    onManageParticipantTicketExcelChange(e) {
      this.participantManageTicketExcelFile = (e.target.files && e.target.files[0]) || null
    },
    mergeTicketImportResult(data) {
      if (!data) return
      const ids = data.userIds || []
      const names = data.usernames || []
      const map = new Map(this.participantRecords.map((x) => [Number(x.userId), x]))
      ids.forEach((uid, idx) => {
        const id = Number(uid)
        if (!Number.isFinite(id) || id <= 0) return
        if (!map.has(id)) {
          map.set(id, {
            userId: id,
            username: names[idx] || '',
            status: 'ASSIGNED',
            score: 0,
            submitTime: ''
          })
        }
      })
      this.participantRecords = Array.from(map.values())
      const created = Number(data.created || 0)
      const skipped = Number(data.skipped || 0)
      const errList = Array.isArray(data.errors) ? data.errors : []
      let msg = `准考证绑定完成：成功 ${ids.length} 人`
      if (created > 0) msg += `，新建 ${created} 人`
      if (skipped > 0) msg += `，跳过 ${skipped} 人`
      if (errList.length) msg += `\n部分失败：\n${errList.slice(0, 5).join('\n')}`
      window.alert(msg)
    },
    appendParticipantsByTicketText() {
      const text = String(this.participantTicketDraftText || '').trim()
      if (!text) {
        window.alert('请输入准考证号')
        return
      }
      fetch('/api/teacher/exam-manage/resolve-participants-by-ticket', {
        method: 'POST',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ ticketsText: text })
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.mergeTicketImportResult(res.data)
            this.participantTicketDraftText = ''
            return
          }
          window.alert(res.message || '准考证绑定失败')
        })
        .catch(() => window.alert('网络异常，准考证绑定失败'))
    },
    importParticipantsByTicketForManage() {
      if (!this.participantManageTicketExcelFile) {
        window.alert('请先选择准考证Excel文件')
        return
      }
      const form = new FormData()
      form.append('file', this.participantManageTicketExcelFile)
      fetch('/api/teacher/exam-manage/import-participants-by-ticket', {
        method: 'POST',
        headers: this.authHeaders(),
        body: form
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.mergeTicketImportResult(res.data)
            return
          }
          window.alert(res.message || '准考证Excel导入失败')
        })
        .catch(() => window.alert('网络异常，准考证Excel导入失败'))
    },
    downloadParticipantTicketTemplate() {
      fetch('/api/teacher/exam-manage/participants-ticket-template', {
        headers: this.authHeaders()
      })
        .then(async (r) => {
          if (!r.ok) {
            window.alert('下载模板失败')
            return
          }
          const blob = await r.blob()
          const url = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'exam_participants_ticket_template.xlsx'
          a.click()
          URL.revokeObjectURL(url)
        })
        .catch(() => window.alert('下载模板失败'))
    },
    mergeAutomanImportResult(data) {
      if (!data) return
      const ids = data.userIds || []
      const names = data.usernames || []
      const map = new Map(this.participantRecords.map((x) => [Number(x.userId), x]))
      ids.forEach((uid, idx) => {
        const id = Number(uid)
        if (!Number.isFinite(id) || id <= 0) return
        if (!map.has(id)) {
          map.set(id, {
            userId: id,
            username: names[idx] || '',
            status: 'ASSIGNED',
            score: 0,
            submitTime: ''
          })
        }
      })
      this.participantRecords = Array.from(map.values())
      const synced = Number(data.synced || ids.length || 0)
      const skipped = Number(data.skipped || 0)
      const missing = Array.isArray(data.missing) ? data.missing : []
      const errList = Array.isArray(data.errors) ? data.errors : []
      let msg = `Automan 导入完成：成功 ${ids.length} 人`
      if (synced > 0) msg += `，同步 ${synced} 人`
      if (skipped > 0) msg += `，跳过 ${skipped} 人`
      if (missing.length) msg += `\n未找到：${missing.slice(0, 8).join(', ')}`
      if (errList.length) msg += `\n部分失败：\n${errList.slice(0, 5).join('\n')}`
      window.alert(msg)
    },
    appendParticipantsByAutomanText() {
      const text = String(this.participantAutomanDraftText || '').trim()
      if (!text) {
        window.alert('请输入 Automan 手机号或账号')
        return
      }
      fetch('/api/teacher/exam-manage/resolve-participants-automan', {
        method: 'POST',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ identifiersText: text })
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.mergeAutomanImportResult(res.data)
            this.participantAutomanDraftText = ''
            return
          }
          window.alert(res.message || 'Automan 导入失败')
        })
        .catch(() => window.alert('网络异常，Automan 导入失败'))
    },
    onManageParticipantAutomanExcelChange(e) {
      this.participantManageAutomanExcelFile = (e.target.files && e.target.files[0]) || null
    },
    importParticipantsByAutomanForManage() {
      if (!this.participantManageAutomanExcelFile) {
        window.alert('请先选择 Automan Excel 文件')
        return
      }
      const form = new FormData()
      form.append('file', this.participantManageAutomanExcelFile)
      fetch('/api/teacher/exam-manage/import-participants-automan', {
        method: 'POST',
        headers: this.authHeaders(),
        body: form
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.mergeAutomanImportResult(res.data)
            return
          }
          window.alert(res.message || 'Automan Excel 导入失败')
        })
        .catch(() => window.alert('网络异常，Automan Excel 导入失败'))
    },
    downloadParticipantAutomanTemplate() {
      fetch('/api/teacher/exam-manage/participants-automan-template', {
        headers: this.authHeaders()
      })
        .then(async (r) => {
          if (!r.ok) {
            window.alert('下载模板失败')
            return
          }
          const blob = await r.blob()
          const url = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'exam_participants_automan_template.xlsx'
          a.click()
          URL.revokeObjectURL(url)
        })
        .catch(() => window.alert('下载模板失败'))
    },
    getCurrentParticipantIds() {
      return Array.from(new Set(this.participantRecords.map((x) => Number(x.userId)).filter((id) => Number.isFinite(id) && id > 0)))
    },
    async batchRemoveParticipants() {
      const removeSet = new Set((this.selectedParticipantIds || []).map((x) => Number(x)))
      if (removeSet.size === 0) {
        window.alert('请先勾选要删除的人员')
        return
      }
      if (!(await appConfirm(`确认从列表中移除已勾选的 ${removeSet.size} 名参考人员吗？（需点击「保存参考人员」才会提交到服务器）`))) return
      this.participantRecords = this.participantRecords.filter((x) => !removeSet.has(Number(x.userId)))
      this.selectedParticipantIds = []
    },
    async clearAllParticipants() {
      if (!this.participantRecords.length) {
        window.alert('列表已为空')
        return
      }
      if (!(await appConfirm('确认清空参考人员列表吗？（需点击「保存参考人员」才会提交到服务器）'))) return
      this.participantRecords = []
      this.selectedParticipantIds = []
    },
    toggleAllParticipants(event) {
      const checked = !!(event && event.target && event.target.checked)
      this.selectedParticipantIds = checked ? this.participantRecords.map((x) => Number(x.userId)) : []
    },
    saveParticipantChanges() {
      if (!this.participantManageExam.id) return
      const payload = {
        examName: this.participantManageExam.examName,
        paperId: this.participantManageExam.paperId,
        startTime: this.fromLocalInput(this.participantManageExam.startTime) || this.participantManageExam.startTime,
        endTime: this.fromLocalInput(this.participantManageExam.endTime) || this.participantManageExam.endTime,
        participantUserIds: this.getCurrentParticipantIds()
      }
      fetch(`/api/teacher/exam-manage/update/${this.participantManageExam.id}`, {
        method: 'PUT',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(payload)
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            this.loadExamList()
            this.loadExamsAndConfigs()
            this.loadParticipantRecords(this.participantManageExam.id)
            window.alert('参考人员已更新')
            return
          }
          window.alert(res.message || '保存参考人员失败')
        })
    },
    openGradingModal(recordRow) {
      if (!recordRow || !recordRow.recordId) {
        window.alert('该学员暂无可阅卷记录')
        return
      }
      this.gradingRecord = {
        recordId: recordRow.recordId,
        userId: recordRow.userId,
        username: recordRow.username || '',
        score: Number(recordRow.score || 0)
      }
      fetch(`/api/student/exam/answers/record/${recordRow.recordId}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            this.gradingRows = res.data || []
            const draft = {}
            this.gradingRows.forEach((row) => {
              if (this.isManualType(row.type)) {
                draft[row.questionId] = Number(row.answerScore ?? 0)
              }
            })
            this.manualScoreDraft = draft
            this.showGradingModal = true
            return
          }
          window.alert(res.message || '加载阅卷详情失败')
        })
    },
    closeGradingModal() {
      this.showGradingModal = false
      this.gradingRows = []
      this.manualScoreDraft = {}
    },
    isManualType(type) {
      const t = String(type || '').toLowerCase()
      return t === 'fill' || t === 'essay' || t === 'coding'
    },
    submitGrading() {
      if (!this.gradingRecord.recordId) return
      const tasks = this.gradingRows
        .filter((row) => this.isManualType(row.type))
        .map((row) => {
          const maxScore = Number(row.maxScore || 0)
          let score = Number(this.manualScoreDraft[row.questionId] ?? 0)
          if (!Number.isFinite(score) || score < 0) score = 0
          if (score > maxScore) score = maxScore
          const isCoding = String(row.type || '').toLowerCase() === 'coding'
          const api = isCoding ? 'grade/coding' : 'grade/manual'
          const params = new URLSearchParams({
            recordId: String(this.gradingRecord.recordId),
            questionId: String(row.questionId),
            score: String(score)
          })
          return fetch(`/api/student/exam/${api}?${params.toString()}`, {
            method: 'POST',
            headers: this.authHeaders()
          }).then((r) => r.json())
        })

      Promise.all(tasks)
        .then(() => {
          const submitParams = new URLSearchParams({ recordId: String(this.gradingRecord.recordId) })
          return fetch(`/api/student/exam/grade/submit?${submitParams.toString()}`, {
            method: 'POST',
            headers: this.authHeaders()
          }).then((r) => r.json())
        })
        .then((res) => {
          if (res.code === 200) {
            this.loadParticipantRecords(this.participantManageExam.id)
            this.loadExamList()
            this.loadGradingRecords()
            window.alert('阅卷完成，成绩已实时更新')
            this.closeGradingModal()
            return
          }
          window.alert(res.message || '提交阅卷失败')
        })
    },
    async publishExam(id) {
      if (!id) return
      try {
        const r = await fetch(`/api/teacher/exam-manage/publish/${id}`, {
          method: 'POST',
          headers: this.authHeaders()
        })
        const raw = await r.text()
        let j = null
        try {
          j = raw ? JSON.parse(raw) : null
        } catch (e) {
          j = null
        }
        if (!r.ok || !j || j.code !== 200) {
          window.alert((j && j.message) || `发布失败（HTTP ${r.status}）`)
          return
        }
        const msg = j.data != null && String(j.data).trim() !== '' ? String(j.data) : '发布成功'
        window.alert(
          msg +
            '\n\n说明：列表中的「未开始/进行中/已结束」由当前时间与开考、结束时间共同决定；若在考试时段内，发布后应为进行中。'
        )
        this.loadExamList()
        this.loadExamsAndConfigs()
      } catch (e) {
        window.alert('发布失败，请检查网络或稍后重试')
      }
    },
    async cancelExam(id) {
      if (!id) return
      try {
        const r = await fetch(`/api/teacher/exam-manage/cancel/${id}`, {
          method: 'POST',
          headers: this.authHeaders()
        })
        const raw = await r.text()
        let j = null
        try {
          j = raw ? JSON.parse(raw) : null
        } catch (e) {
          j = null
        }
        if (!r.ok || !j || j.code !== 200) {
          window.alert((j && j.message) || `取消失败（HTTP ${r.status}）`)
          return
        }
        window.alert(j.data != null && String(j.data).trim() !== '' ? String(j.data) : '已取消考试')
        this.loadExamList()
        this.loadExamsAndConfigs()
      } catch (e) {
        window.alert('取消失败，请检查网络或稍后重试')
      }
    },
    async deleteExam(id) {
      if (!id) return
      if (!(await appConfirm('确认删除该考试吗？删除后不可恢复。'))) return
      try {
        const r = await fetch(`/api/teacher/exam-manage/delete/${id}`, {
          method: 'DELETE',
          headers: this.authHeaders()
        })
        const raw = await r.text()
        let j = null
        try {
          j = raw ? JSON.parse(raw) : null
        } catch (e) {
          j = null
        }
        if (!r.ok || !j || j.code !== 200) {
          window.alert((j && j.message) || `删除失败（HTTP ${r.status}）`)
          return
        }
        window.alert(j.data != null && String(j.data).trim() !== '' ? String(j.data) : '已删除')
        if (this.examList.length <= 1 && this.examPage > 0) {
          this.examPage -= 1
        }
        this.loadExamList()
        this.loadExamsAndConfigs()
      } catch (e) {
        window.alert('删除失败，请检查网络或稍后重试')
      }
    },
    async deletePaper() {
      if (!this.selectedPaperId) return
      if (!(await appConfirm('确认删除当前试卷吗？该操作会影响绑定该试卷的考试。'))) return
      fetch(`/api/crud/exam-paper/${this.selectedPaperId}`, {
        method: 'DELETE'
      })
        .then(() => {
          this.clearForm()
          this.loadPapers()
          this.loadExamsAndConfigs()
          this.loadExamList()
          window.alert('试卷已删除')
        })
    },
    downloadParticipantTemplate() {
      fetch('/api/teacher/exam-manage/participants-template', {
        headers: this.authHeaders()
      })
        .then((r) => r.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'exam_participants_template.xlsx'
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },
    onParticipantExcelChange(e) {
      this.participantExcelFile = (e.target.files && e.target.files[0]) || null
    },
    importParticipants() {
      if (!this.participantExcelFile) {
        window.alert('请先选择Excel文件')
        return
      }
      const form = new FormData()
      form.append('file', this.participantExcelFile)
      fetch('/api/teacher/exam-manage/import-participants', {
        method: 'POST',
        headers: this.authHeaders(),
        body: form
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.examForm.participantUserIdsText = (res.data.userIds || []).join(',')
            return
          }
          window.alert(res.message || '导入失败')
        })
    },
    resetExamForm() {
      this.selectedExamManageId = null
      this.examForm = {
        examName: '',
        paperId: null,
        startTime: '',
        endTime: '',
        showAnalysis: 1,
        showAnswerAfterSubmit: 0,
        allowRedo: 0,
        participantUserIdsText: ''
      }
    },
    createOrUpdatePaper() {
      if (!this.form.paperName || !this.form.paperName.trim()) {
        window.alert('请输入试卷名称')
        return
      }

      const paperPayload = {
        paperName: this.form.paperName,
        totalScore: this.form.totalScore,
        examDuration: this.form.examDuration,
        passScore: this.form.passScore,
        createType: 'manual'
      }

      const paperApi = this.selectedPaperId
        ? `/api/crud/exam-paper/${this.selectedPaperId}`
        : '/api/crud/exam-paper'
      const method = this.selectedPaperId ? 'PUT' : 'POST'
      fetch(paperApi, {
        method,
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(paperPayload)
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code !== 200 && res.code !== undefined) {
            throw new Error(res.message || '保存试卷失败')
          }
          const paperId = res.data && res.data.id ? res.data.id : this.selectedPaperId
          if (!paperId) {
            throw new Error('保存试卷失败：未获得paperId')
          }
          this.selectedPaperId = paperId
          window.alert('保存成功（开考时间请到「考试管理」中设置）')
          this.loadPapers()
          this.selectPaper(this.selectedPaperId)
          this.loadCandidateQuestions()
        })
        .catch((e) => {
          window.alert('保存失败：' + ((e && e.message) || '未知错误'))
        })
    },

    loadCandidateQuestions() {
      const params = new URLSearchParams({
        page: '0',
        size: '200'
      })
      if (this.questionFilters.keyword) params.append('keyword', this.questionFilters.keyword)
      if (this.questionFilters.type) params.append('type', this.questionFilters.type)
      if (this.questionFilters.difficulty) params.append('difficulty', this.questionFilters.difficulty)
      if (this.questionFilters.bankId) params.append('bankId', String(this.questionFilters.bankId))
      if (this.questionFilters.tagId) params.append('tagId', String(this.questionFilters.tagId))

      fetch(`/api/teacher/question/questions?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then(async (r) => {
          const res = await r.json().catch(() => ({}))
          if (!r.ok) {
            window.alert((res && res.message) || `加载候选题目失败（${r.status}）`)
            return
          }
          if (res.code !== 200) {
            window.alert(res.message || '加载候选题目失败')
            this.candidateQuestions = []
            return
          }
          this.candidateQuestions = (res.data && res.data.content) || []
          this.candidatePage = 1
          if (this.candidateQuestions.length === 0) {
            window.alert('未找到符合条件的候选题目，请调整筛选条件后再试')
          }
        })
        .catch(() => {
          window.alert('加载候选题目失败，请检查网络或稍后重试')
        })
    },
    selectAllCandidateQuestions() {
      const ids = (this.candidateQuestions || []).map((q) => Number(q.question && q.question.id)).filter((id) => Number.isFinite(id))
      const merged = new Set([...(this.selectedQuestionIds || []).map((x) => Number(x)), ...ids].filter((x) => Number.isFinite(x) && x > 0))
      this.selectedQuestionIds = Array.from(merged)
    },
    /**
     * 将勾选 ID 解析为组卷用 { questionId, score }；依次查候选列表、已加载题目详情、接口。
     */
    async resolveComposeItemsForIds(rawIds) {
      const ids = [...new Set((rawIds || []).map((x) => Number(x)).filter((x) => Number.isFinite(x) && x > 0))]
      const items = []
      for (const id of ids) {
        const cand = (this.candidateQuestions || []).find((q) => Number(q && q.question && q.question.id) === id)
        if (cand && cand.question) {
          items.push({ questionId: id, score: Number(cand.question.score || 0) })
          continue
        }
        const det = this.questionDetailMap[id]
        if (det) {
          items.push({ questionId: id, score: Number(det.score || 0) })
          continue
        }
        try {
          const r = await fetch(`/api/crud/question/${id}`, { headers: this.authHeaders() })
          const j = await r.json()
          if (j && j.data) {
            items.push({ questionId: id, score: Number(j.data.score || 0) })
            continue
          }
        } catch (e) {
          void e
        }
        window.alert(`无法获取题目 ${id} 的分值信息，请取消勾选或先「加载候选题目」包含该题后再试`)
        return null
      }
      return items
    },
    async replacePaperCompose(items) {
      const body = (items || []).map((it) => ({
        questionId: it.questionId,
        score: Number(it.score || 0)
      }))
      const r = await fetch(`/api/teacher/paper-compose/${this.selectedPaperId}/replace-questions`, {
        method: 'POST',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(body)
      })
      const j = await r.json()
      if (j.code !== 200 && typeof j.code !== 'undefined') {
        throw new Error(j.message || '保存组卷失败')
      }
    },
    async appendPaperCompose(items) {
      const body = (items || []).map((it) => ({
        questionId: it.questionId,
        score: Number(it.score || 0)
      }))
      const r = await fetch(`/api/teacher/paper-compose/${this.selectedPaperId}/append-questions`, {
        method: 'POST',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(body)
      })
      const j = await r.json()
      if (j.code !== 200 && typeof j.code !== 'undefined') {
        throw new Error(j.message || '追加题目失败')
      }
    },
    async saveFixed() {
      if (!this.selectedPaperId) return
      if (!this.selectedQuestionIds || this.selectedQuestionIds.length === 0) {
        window.alert('请先勾选题目')
        return
      }
      const items = await this.resolveComposeItemsForIds(this.selectedQuestionIds)
      if (!items || !items.length) return
      items.sort((a, b) => a.questionId - b.questionId)
      try {
        await this.replacePaperCompose(items)
        await this.loadPaperQuestions()
        window.alert('保存固定组卷成功（已覆盖整卷题目）')
      } catch (err) {
        window.alert(err && err.message ? err.message : '保存固定组卷失败')
      }
    },
    async appendCheckedQuestionsToPaper() {
      if (!this.selectedPaperId) {
        window.alert('请先选择试卷')
        return
      }
      if (!this.selectedQuestionIds || this.selectedQuestionIds.length === 0) {
        window.alert('请先勾选要追加的题目')
        return
      }
      const items = await this.resolveComposeItemsForIds(this.selectedQuestionIds)
      if (!items || !items.length) return
      const existingIds = new Set((this.paperQuestions || []).map((pq) => Number(pq.questionId)).filter((x) => Number.isFinite(x) && x > 0))
      const toAdd = items.filter((it) => !existingIds.has(Number(it.questionId)))
      if (!toAdd.length) {
        window.alert('所选题目均已在本试卷中，无需追加')
        return
      }
      try {
        await this.appendPaperCompose(toAdd)
        await this.loadPaperQuestions()
        window.alert(`已追加 ${toAdd.length} 道题到当前试卷`)
      } catch (err) {
        window.alert(err && err.message ? err.message : '追加题目失败')
      }
    },
    saveRandom() {
      if (!this.selectedPaperId) return
      if (!this.randomForm.count || this.randomForm.count <= 0) {
        window.alert('请输入正确的题目数量')
        return
      }

      const params = new URLSearchParams({
        page: '0',
        size: '1000'
      })
      if (this.randomForm.keyword) params.append('keyword', this.randomForm.keyword)
      if (this.randomForm.type) params.append('type', this.randomForm.type)
      if (this.randomForm.difficulty) params.append('difficulty', this.randomForm.difficulty)
      if (this.randomForm.bankId) params.append('bankId', String(this.randomForm.bankId))
      if (this.randomForm.tagId) params.append('tagId', String(this.randomForm.tagId))

      fetch(`/api/teacher/question/questions?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          const candidates = (res.data && res.data.content) || []
          if (candidates.length === 0) {
            window.alert('没有匹配到题目')
            return
          }
          const need = Math.min(this.randomForm.count, candidates.length)
          // shuffle
          const shuffled = candidates.slice().sort(() => Math.random() - 0.5)
          const selected = shuffled.slice(0, need)
          this.candidateQuestions = candidates
          this.selectedQuestionIds = selected.map((x) => x.question.id)
          return this.saveFixed()
        })
    },
    async appendRandomQuestionsToPaper() {
      if (!this.selectedPaperId) {
        window.alert('请先选择试卷')
        return
      }
      if (!this.randomForm.count || this.randomForm.count <= 0) {
        window.alert('请输入正确的题目数量')
        return
      }
      const params = new URLSearchParams({
        page: '0',
        size: '1000'
      })
      if (this.randomForm.keyword) params.append('keyword', this.randomForm.keyword)
      if (this.randomForm.type) params.append('type', this.randomForm.type)
      if (this.randomForm.difficulty) params.append('difficulty', this.randomForm.difficulty)
      if (this.randomForm.bankId) params.append('bankId', String(this.randomForm.bankId))
      if (this.randomForm.tagId) params.append('tagId', String(this.randomForm.tagId))
      try {
        const res = await fetch(`/api/teacher/question/questions?${params.toString()}`, {
          headers: this.authHeaders()
        }).then((r) => r.json())
        const candidates = (res.data && res.data.content) || []
        if (candidates.length === 0) {
          window.alert('没有匹配到题目')
          return
        }
        const existingIds = new Set((this.paperQuestions || []).map((pq) => Number(pq.questionId)).filter((x) => Number.isFinite(x) && x > 0))
        const pool = candidates.filter((c) => c && c.question && !existingIds.has(Number(c.question.id)))
        if (pool.length === 0) {
          window.alert('当前条件下没有可追加的新题（可能已全部在本试卷中）')
          return
        }
        const need = Math.min(this.randomForm.count, pool.length)
        const shuffled = pool.slice().sort(() => Math.random() - 0.5)
        const picked = shuffled.slice(0, need)
        const items = picked.map((c) => ({
          questionId: Number(c.question.id),
          score: Number(c.question.score || 0)
        }))
        await this.appendPaperCompose(items)
        await this.loadPaperQuestions()
        window.alert(`已随机追加 ${items.length} 道题到当前试卷`)
      } catch (err) {
        window.alert(err && err.message ? err.message : '随机追加失败')
      }
    },
    onExcelChange(e) {
      const file = e.target.files && e.target.files[0]
      this.excelFile = file || null
    },
    importExcel() {
      if (!this.excelFile) {
        window.alert('请先选择xlsx文件')
        return
      }
      const formData = new FormData()
      formData.append('file', this.excelFile)
      fetch('/api/teacher/paper/import-excel', {
        method: 'POST',
        body: formData
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            window.alert(res.data || '导入成功')
            this.excelFile = null
            this.loadPapers()
            this.loadExamsAndConfigs()
          } else {
            window.alert(res.message || '导入失败')
          }
        })
    }
  },
  computed: {
    paperEditOptionLetters() {
      return ['A', 'B', 'C', 'D']
    },
    examImporterSummary() {
      return this.buildImporterSummary(this.participantRecords)
    },
    paperImporterSummary() {
      return this.buildImporterSummary(this.paperParticipantRows)
    },
    currentPaperQuestionScore() {
      return this.calcQuestionTotal(this.paperQuestions)
    },
    currentPaperTotalScore() {
      return this.getCurrentPaperTotalScore()
    },
    paperQuestionTotalPages() {
      const total = Math.ceil((this.paperQuestions.length || 0) / this.paperQuestionPageSize)
      return total > 0 ? total : 1
    },
    pagedPaperQuestions() {
      const totalPages = this.paperQuestionTotalPages
      const safePage = Math.min(Math.max(Number(this.paperQuestionPage) || 1, 1), totalPages)
      const start = (safePage - 1) * this.paperQuestionPageSize
      const end = start + this.paperQuestionPageSize
      return this.paperQuestions.slice(start, end)
    },
    candidateTotalPages() {
      const total = Math.ceil((this.candidateQuestions.length || 0) / this.candidatePageSize)
      return total > 0 ? total : 1
    },
    pagedCandidateQuestions() {
      const totalPages = this.candidateTotalPages
      const safePage = Math.min(Math.max(Number(this.candidatePage) || 1, 1), totalPages)
      const start = (safePage - 1) * this.candidatePageSize
      const end = start + this.candidatePageSize
      return this.candidateQuestions.slice(start, end)
    },
    isAllCurrentPageChecked() {
      if (!this.pagedPaperQuestions.length) return false
      const selected = new Set(this.selectedPaperQuestionIds)
      return this.pagedPaperQuestions.every((x) => selected.has(x.id))
    },
    isAllParticipantsChecked() {
      return this.participantRecords.length > 0 && this.selectedParticipantIds.length === this.participantRecords.length
    },
    isAllSearchUsersChecked() {
      return this.filteredUserSearchRows.length > 0 && this.selectedSearchUserIds.length === this.filteredUserSearchRows.length
    },
    previewGradingTotal() {
      let total = 0
      this.gradingRows.forEach((row) => {
        if (this.isManualType(row.type)) {
          const maxScore = Number(row.maxScore || 0)
          let score = Number(this.manualScoreDraft[row.questionId] ?? 0)
          if (!Number.isFinite(score) || score < 0) score = 0
          if (score > maxScore) score = maxScore
          total += score
          return
        }
        total += Number(row.answerScore || 0)
      })
      return total
    },
    filteredUserSearchRows() {
      // 学员已由服务端按 excludeUserIds 排除；此处再过滤未建号准考证是否已在名单中
      if (!this.hideAddedUsersInSearch) return this.userSearchRows
      const existedTickets = new Set(
        this.participantRecords
          .map((x) => String(x.ticketNo || x.username || '').trim())
          .filter(Boolean)
      )
      return this.userSearchRows.filter((x) => {
        const tn = String(x.ticketNo || '').trim()
        if (tn && existedTickets.has(tn)) return false
        return true
      })
    },
    filteredGradingRecordRows() {
      let rows = this.gradingRecordRows
      if (this.onlySubmittedForGrading) {
        rows = rows.filter((r) => String(r.submitTime || '').trim().length > 0)
      }
      if (this.gradingUserKeyword && this.gradingUserKeyword.trim()) {
        const kw = this.gradingUserKeyword.trim().toLowerCase()
        rows = rows.filter((r) => {
          const username = String(r.username || '').toLowerCase()
          const userId = String(r.userId || '')
          return username.includes(kw) || userId.includes(kw)
        })
      }
      if (this.gradingStatusFilter === 'all') return rows
      if (this.gradingStatusFilter === 'graded') {
        return rows.filter((r) => String(r.status || '').toUpperCase() === 'GRADED')
      }
      return rows.filter((r) => String(r.status || '').toUpperCase() !== 'GRADED')
    }
  }
}
</script>

<style scoped>
.teacher-page {
  min-height: 100vh;
  padding: 20px;
  background:
    radial-gradient(circle at 8% 10%, rgba(82, 149, 255, 0.16), transparent 34%),
    radial-gradient(circle at 92% 20%, rgba(120, 170, 255, 0.14), transparent 30%),
    linear-gradient(160deg, #f7faff 0%, #eef4ff 55%, #f8fbff 100%);
  color: #1f2a44;
}

.side-nav {
  width: 240px;
  min-height: calc(100vh - 40px);
  margin-right: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid #d8e6ff;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(63, 108, 199, 0.1);
  backdrop-filter: blur(8px);
  flex-shrink: 0;
}

.side-nav.collapsed {
  width: 76px;
}

.side-nav.collapsed .nav-text {
  display: none;
}

.side-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.collapse-btn {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1px solid #d8e6ff;
  background: #f6f9ff;
  color: #335896;
  font-size: 12px;
}

.sub-btn {
  border: 1px solid #d8e6ff;
  border-radius: 10px;
  padding: 10px 12px;
  color: #335896;
  background: #f6f9ff;
  text-align: left;
  transition: all 0.2s ease;
}

.sub-btn:hover {
  background: #eef5ff;
  border-color: #bfd6ff;
  transform: translateY(-1px);
}

.sub-btn.active {
  background: linear-gradient(120deg, #2f6feb, #5ca2ff);
  color: #ffffff;
  border-color: transparent;
}

.content-area {
  flex: 1;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 14px 16px;
  border-radius: 12px;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.82), rgba(245, 250, 255, 0.92));
  border: 1px solid #d8e6ff;
  box-shadow: 0 10px 26px rgba(48, 96, 192, 0.1);
}

.card-box {
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.82), rgba(245, 250, 255, 0.92));
  border: 1px solid #d8e6ff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 10px 26px rgba(48, 96, 192, 0.1);
}

.result-shell {
  border: 1px solid rgba(145, 180, 240, 0.35);
  border-radius: 12px;
  padding: 12px;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.82), rgba(245, 250, 255, 0.92));
}

.title-cell {
  max-width: 420px;
  white-space: pre-wrap;
  word-break: break-word;
}

.candidate-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  max-height: 620px;
  overflow: auto;
  padding-right: 8px;
}

.candidate-item {
  padding: 12px;
  border: 1px solid rgba(145, 180, 240, 0.35);
  border-radius: 10px;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.75), rgba(245, 250, 255, 0.9));
  margin-bottom: 12px;
}

.card-box-sm {
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.75), rgba(245, 250, 255, 0.9));
  border: 1px dashed rgba(120, 160, 235, 0.4);
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 16px;
}

.ticket-assign-box {
  border-color: rgba(47, 93, 165, 0.45);
  background: linear-gradient(180deg, #f7fbff 0%, #eef5ff 100%);
}

.topbar h2,
.card-box h4,
.card-box h5 {
  color: #1f2a44;
  font-weight: 700;
}

.table :deep(th),
.table :deep(td) {
  vertical-align: middle;
}

.paper-question-table {
  table-layout: fixed;
}

.paper-question-table .col-id {
  width: 90px;
}

.paper-question-table .col-type {
  width: 90px;
}

.paper-question-table .col-difficulty {
  width: 90px;
}

.paper-question-table .col-score {
  width: 130px;
}

.paper-question-table .col-action {
  width: 280px;
}

.paper-question-table .col-title {
  width: auto;
  min-width: 420px;
}

.col-title-cell {
  white-space: pre-wrap;
  line-height: 1.55;
  color: #1f2a44;
}

.action-cell .btn {
  white-space: nowrap;
}

.btn {
  border-radius: 10px;
  font-weight: 600;
}

.paper-form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px 14px;
}

.paper-form-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.paper-form-label {
  min-width: 110px;
  margin: 0;
  color: #335896;
  font-weight: 600;
  text-align: right;
  white-space: nowrap;
}

.paper-form-item .form-control,
.paper-form-item .form-select {
  flex: 1;
}

.paper-form-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.participant-btn {
  min-width: 220px;
}

.participant-file-input {
  max-width: 320px;
}

.participant-input {
  max-width: 640px;
}

.participant-line {
  display: flex;
  align-items: center;
  gap: 10px;
}

.participant-line-label {
  width: 130px;
  flex-shrink: 0;
  text-align: right;
  color: #335896;
  font-weight: 600;
}

.participant-line-content {
  flex: 1;
  display: flex;
  align-items: center;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 74px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid transparent;
}

.status-not-start {
  color: #2f6feb;
  background: rgba(67, 130, 255, 0.12);
  border-color: rgba(67, 130, 255, 0.26);
}

.status-ing {
  color: #1d7f4e;
  background: rgba(48, 187, 112, 0.14);
  border-color: rgba(48, 187, 112, 0.26);
}

.status-end {
  color: #9b5a00;
  background: rgba(255, 181, 68, 0.2);
  border-color: rgba(255, 181, 68, 0.34);
}

.form-control:focus,
.form-select:focus {
  border-color: #9ec2ff;
  box-shadow: 0 0 0 0.2rem rgba(92, 162, 255, 0.2);
}

.modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(18, 36, 76, 0.35);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1200;
}

.modal-panel {
  width: min(900px, 100%);
  max-height: calc(100vh - 40px);
  overflow: auto;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.96), rgba(244, 250, 255, 0.98));
  border: 1px solid #d8e6ff;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 20px 50px rgba(35, 72, 150, 0.22);
}

.modal-panel.modal-wide {
  width: min(1080px, 100%);
}

.teacher-q-thumb {
  max-width: 120px;
  max-height: 80px;
  object-fit: contain;
  border-radius: 6px;
  border: 1px solid #c5d6f5;
  cursor: zoom-in;
  background: #fff;
}

@media (max-width: 992px) {
  .teacher-page {
    flex-direction: column;
  }

  .side-nav {
    width: 100%;
    min-height: auto;
    margin-right: 0;
    margin-bottom: 12px;
  }

  .paper-form-grid {
    grid-template-columns: 1fr;
  }

  .paper-form-item {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }

  .paper-form-label {
    min-width: 0;
    text-align: left;
  }

  .participant-btn,
  .participant-file-input {
    max-width: 100%;
    min-width: 0;
  }

  .participant-input {
    max-width: 100%;
  }

  .participant-line {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }

  .participant-line-label {
    width: auto;
    text-align: left;
  }

  .candidate-grid {
    grid-template-columns: 1fr;
  }
}
</style>

